function getFocusableElements(e) {
  return Array.from(
    e.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
  e.removeAttribute("role"),
    e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open")),
    e.nextElementSibling.getAttribute("id") &&
    e.setAttribute("aria-controls", e.nextElementSibling.id),
    e.addEventListener("click", (e) => {
      e.currentTarget.setAttribute(
        "aria-expanded",
        !e.currentTarget.closest("details").hasAttribute("open")
      );
    }),
    e.closest("header-drawer") ||
    e.parentElement.addEventListener("keyup", onKeyUpEscape);
});
document.querySelector('#menu-drawer .menu-drawer__search').addEventListener('click', function () {
  document.querySelector('header-drawer details').classList.remove('menu-opening');
  document.querySelector('header-drawer details').removeAttribute('open');
  document.querySelector('header-drawer details summary').setAttribute('aria-expanded', 'false');
  document.querySelector('details-modal.header__search details').setAttribute('open', 'true');
  setTimeout(function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, 100);
});
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
  var i = getFocusableElements(e),
    s = i[0],
    o = i[i.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      (t.target === e || t.target === o || t.target === s) &&
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (t) {
      "TAB" === t.code.toUpperCase() &&
        (t.target !== o || t.shiftKey || (t.preventDefault(), s.focus()),
          (t.target === e || t.target === s) &&
          t.shiftKey &&
          (t.preventDefault(), o.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    t.focus();
}
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  let e = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ],
    t = null,
    i = null;
  window.addEventListener("keydown", (t) => {
    e.includes(t.code.toUpperCase()) && (i = !1);
  }),
    window.addEventListener("mousedown", (e) => {
      i = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        t && t.classList.remove("focused"),
          i || (t = document.activeElement).classList.add("focused");
      },
      !0
    );
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((e) => {
    e.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((e) => e.pause()),
    document.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    });
}
function removeTrapFocus(e = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && e.focus();
}
function onKeyUpEscape(e) {
  if ("ESCAPE" !== e.code.toUpperCase()) return;
  let t = e.target.closest("details[open]");
  if (!t) return;
  let i = t.querySelector("summary");
  t.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onButtonClick.bind(this))
      );
  }
  onButtonClick(e) {
    e.preventDefault();
    let t = this.input.value;
    "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
}
function debounce(e, t) {
  let i;
  return (...s) => {
    clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
  };
}
function fetchConfig(e = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${e}` },
  };
}
customElements.define("quantity-input", QuantityInput),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (e, t) {
    return function () {
      return e.apply(t, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (e, t) {
    for (var i = 0, s = e.options.length; i < s; i++) {
      var o = e.options[i];
      if (t == o.value || t == o.innerHTML) return (e.selectedIndex = i), i;
    }
  }),
  (Shopify.addListener = function (e, t, i) {
    e.addEventListener
      ? e.addEventListener(t, i, !1)
      : e.attachEvent("on" + t, i);
  }),
  (Shopify.postLink = function (e, t) {
    var i = (t = t || {}).method || "post",
      s = t.parameters || {},
      o = document.createElement("form");
    for (var r in (o.setAttribute("method", i),
      o.setAttribute("action", e),
      s)) {
      var n = document.createElement("input");
      n.setAttribute("type", "hidden"),
        n.setAttribute("name", r),
        n.setAttribute("value", s[r]),
        o.appendChild(n);
    }
    document.body.appendChild(o), o.submit(), document.body.removeChild(o);
  }),
  (Shopify.CountryProvinceSelector = function (e, t, i) {
    (this.countryEl = document.getElementById(e)),
      (this.provinceEl = document.getElementById(t)),
      (this.provinceContainer = document.getElementById(i.hideElement || t)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var e = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
    },
    initProvince: function () {
      var e = this.provinceEl.getAttribute("data-default");
      e &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, e);
    },
    countryHandler: function (e) {
      var t = this.countryEl.options[this.countryEl.selectedIndex],
        i = JSON.parse(t.getAttribute("data-provinces"));
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var s = 0; s < i.length; s++) {
          var t = document.createElement("option");
          (t.value = i[s][0]),
            (t.innerHTML = i[s][1]),
            this.provinceEl.appendChild(t);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (e) {
      for (; e.firstChild;) e.removeChild(e.firstChild);
    },
    setOptions: function (e, t) {
      for (var i = 0; i < t.length; i++) {
        var s = document.createElement("option");
        (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
      }
      t.length;
    },
  });
class MenuDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      "iPhone" === navigator.platform &&
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      ),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((e) =>
      e.addEventListener("click", this.onSummaryClick.bind(this))
    ),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
  }
  onKeyUp(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    let t = e.target.closest("details[open]");
    t &&
      (t === this.mainDetailsToggle
        ? this.closeMenuDrawer(
          e,
          this.mainDetailsToggle.querySelector("summary")
        )
        : this.closeSubmenu(t));
  }
  onSummaryClick(e) {
    let t = e.currentTarget,
      i = t.parentNode,
      s = i.closest(".has-submenu"),
      o = i.hasAttribute("open"),
      r = window.matchMedia("(prefers-reduced-motion: reduce)");
    function n() {
      trapFocus(t.nextElementSibling, i.querySelector("button")),
        t.nextElementSibling.removeEventListener("transitionend", n);
    }
    i === this.mainDetailsToggle
      ? (o && e.preventDefault(),
        o ? this.closeMenuDrawer(e, t) : this.openMenuDrawer(t))
      : setTimeout(() => {
        i.classList.add("menu-opening"),
          t.setAttribute("aria-expanded", !0),
          s && s.classList.add("submenu-open"),
          !r || r.matches
            ? n()
            : t.nextElementSibling.addEventListener("transitionend", n);
      }, 100);
  }
  openMenuDrawer(e) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(e, t = !1) {
    void 0 !== e &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
        this.mainDetailsToggle.classList.contains("mobile-facets__disclosure") ||
        this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
          e.removeAttribute("open"), e.classList.remove("menu-opening");
        }),
        this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((e) => {
          e.classList.remove("submenu-open");
        }),
        document.body.classList.remove(
          `overflow-hidden-${this.dataset.breakpoint}`
        ),
        removeTrapFocus(t),
        this.closeAnimation(this.mainDetailsToggle));
  }
  onFocusOut(e) {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(e) {
    let t = e.currentTarget.closest("details");
    this.closeSubmenu(t);
  }
  closeSubmenu(e) {
    let t = e.closest(".submenu-open");
    t && t.classList.remove("submenu-open"),
      e.classList.remove("menu-opening"),
      e.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(e.querySelector("summary")),
      this.closeAnimation(e);
  }
  closeAnimation(e) {
    let t,
      i = (s) => {
        void 0 === t && (t = s);
        let o = s - t;
        o < 400
          ? window.requestAnimationFrame(i)
          : (e.removeAttribute("open"),
            e.closest("details[open]") &&
            trapFocus(
              e.closest("details[open]"),
              e.querySelector("summary")
            ));
      };
    window.requestAnimationFrame(i);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  openMenuDrawer(e) {
    (this.header =
      this.header || document.getElementById("shopify-section-header")),
      (this.borderOffset =
        this.borderOffset ||
          this.closest(".header-wrapper").classList.contains(
            "header-wrapper--border-bottom"
          )
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      ),
      this.header.classList.add("menu-open"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      e.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, e),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(e, t) {
    super.closeMenuDrawer(e, t),
      console.log(header),
      this.header.classList.remove("menu-open");
  }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this, !1)
      ),
      this.addEventListener("keyup", (e) => {
        "ESCAPE" === e.code.toUpperCase() && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener("pointerup", (e) => {
          "mouse" !== e.pointerType ||
            e.target.closest("deferred-media, product-model") ||
            this.hide();
        })
        : this.addEventListener("click", (e) => {
          e.target === this && this.hide();
        });
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(e) {
    this.openedBy = e;
    let t = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      t && t.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove("overflow-hidden"),
      document.body.dispatchEvent(new CustomEvent("modalClosed")),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector("button");
    if (!e) return;
    e.addEventListener("click", () => {
      let t = document.querySelector(this.getAttribute("data-modal"));
      t && t.show(e);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    let e = this.querySelector('[id^="Deferred-Poster-"]');
    if (!e) return;
    e.classList.contains("no_poster")
      ? ((this.checkIfVideoInView = this.checkIfVideoInView.bind(this)),
        document.addEventListener("scroll", this.checkIfVideoInView))
      : e.addEventListener("click", this.loadContent.bind(this));
  }
  checkIfVideoInView() {
    let e = this.querySelector('[id^="Deferred-Poster-"]'),
      t = e.getBoundingClientRect(),
      i = t.top - 50,
      s = t.bottom + 50,
      o = i <= window.innerHeight && s >= 0;
    o && (this.loadContent(), this.removeVideoListener());
  }
  removeVideoListener(e) {
    document.removeEventListener("scroll", this.checkIfVideoInView);
  }
  loadContent() {
    if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
      let e = document.createElement("div");
      e.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0)
      ),
        this.setAttribute("loaded", !0),
        this.appendChild(
          e.querySelector("video, model-viewer, iframe")
        ).focus();
      let t = this.closest(".card-wrapper__ad");
      t && t.classList.add("video-loaded");
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
        (this.slider = this.querySelector('[id^="Slider-"]')),
        (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
        (this.enableSliderLooping = !1),
        (this.sliderDots = this.querySelector(".slider-dots")),
        (this.pageCount = this.querySelector(".slider-counter--current")),
        (this.pageTotal = this.querySelector(".slider-counter--total")),
        (this.prevButton = this.querySelector('button[name="previous"]')),
        (this.nextButton = this.querySelector('button[name="next"]')),
        (this.firstSlide = this.sliderItems[0]),
        (this.lastSlide = this.sliderItems[0]),
        (this.index = 0),
        (this.fixedOffset = 0),
        !this.slider || !this.nextButton)
    )
      return;
    this.initPages();
    let e = new ResizeObserver((e) => this.initPages());
    e.observe(this.slider);
    let t = new MutationObserver((e) => {
      (this.sliderItems = this.querySelectorAll("li")),
        (this.firstSlide = this.sliderItems[0]),
        (this.lastSlide = this.sliderItems[0]);
    });
    t.observe(this.slider, {
      childList: !0,
      subtree: !0,
      attributes: !1,
      characterData: !1,
    }),
      this.slider.addEventListener("scroll", this.update.bind(this)),
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this)),
      this.sliderDots &&
      ((this.sliderDot = this.sliderDots.querySelectorAll("div")),
        this.sliderDots.addEventListener("click", this.onDotClick.bind(this)));
  }
  initPages() {
    if (
      ((this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        (e) => e.clientWidth > 0
      )),
        (this.sliderLastItem =
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1]),
        !(this.sliderItemsToShow.length < 2))
    ) {
      if (
        ((this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetLeft -
          this.sliderItemsToShow[0].offsetLeft),
          (this.slidesPerPage = Math.floor(
            this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth
          )),
          (this.totalPages =
            this.sliderItemsToShow.length - this.slidesPerPage + 1),
          (this.lastSlide = this.sliderItems[this.totalPages - 1]),
          !this.slider.classList.contains("loaded") && this.enableSliderLooping)
      ) {
        let e = this.firstSlide.cloneNode(!0),
          t = this.lastSlide.cloneNode(!0);
        e.classList.add("cloned"),
          t.classList.add("cloned"),
          this.slider.appendChild(e),
          this.slider.insertBefore(t, this.firstSlide),
          (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
          this.slider.classList.add("loaded"),
          this.slider.scrollTo({ left: this.firstSlide.offsetLeft });
      }
      this.update();
    }
  }
  update() {
    if (
      this.pageCount &&
      this.pageTotal &&
      ((this.currentPage =
        Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) +
        1),
        this.slider.classList.contains("loaded") &&
        this.enableSliderLooping &&
        (this.currentPage =
          Math.round(
            (this.slider.scrollLeft - this.sliderLastItem.clientWidth) /
            this.sliderLastItem.clientWidth
          ) + 1),
        this.currentPage > this.totalPages && (this.currentPage = 1),
        (this.pageCount.textContent = this.currentPage),
        (this.pageTotal.textContent = this.totalPages),
        this.sliderDots)
    ) {
      var e = this.sliderDots.querySelectorAll("div"),
        t = Array.from(this.sliderItems).filter(
          (e) =>
            "none" != window.getComputedStyle(e).getPropertyValue("display")
        );
      [].forEach.call(e, function (e) {
        e.classList.remove("slider-dots--show");
      });
      for (var i = 0; i < t.length; i++)
        e[i].classList.add("slider-dots--show");
    }
  }
  onScroll() {
    if (this.slider.scrollLeft.toFixed() === this.fixedOffset) {
      if (this.index < 0 || this.index == this.totalPages) {
        let e = this.sliderLastItem.clientWidth,
          t = 0;
        this.index < 0 &&
          ((e = this.sliderLastItem.clientWidth * this.totalPages),
            (t = this.totalPages - 1)),
          (this.slider.style.scrollBehavior = "auto"),
          (this.index = t),
          this.slider.scrollTo({ left: e }),
          this.slider.style.removeProperty("scroll-behavior");
      }
      this.slider.removeEventListener("scroll", this.onScroll);
    }
    this.sliderDots &&
      ([].forEach.call(this.sliderDot, function (e) {
        e.classList.remove("current");
      }),
        this.sliderDot[this.index].classList.add("current"));
  }
  scrollToSlide(e) {
    (this.fixedOffset = e.toFixed()),
      this.slider.addEventListener("scroll", this.onScroll.bind(this)),
      this.onScroll(),
      this.slider.scrollTo({ left: e });
  }
  onButtonClick(e) {
    e.preventDefault();
    let t = e.currentTarget.dataset.step || 1;
    (this.slideScrollPosition =
      "next" === e.currentTarget.name
        ? this.slider.scrollLeft + t * this.sliderItemOffset
        : this.slider.scrollLeft - t * this.sliderItemOffset),
      (this.index =
        "next" === e.currentTarget.name
          ? (this.index += 1)
          : (this.index -= 1)),
      this.scrollToSlide(this.slideScrollPosition);
  }
  onDotClick(e) {
    var t = Array.from(this.sliderItems).filter(
      (e) => "none" != window.getComputedStyle(e).getPropertyValue("display")
    );
    (this.index = e.target.textContent),
      this.scrollToSlide(
        t[e.target.textContent].clientWidth * e.target.textContent
      );
  }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    if (
      (super(),
        (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
        (this.enableSliderLooping = !0),
        !this.sliderControlWrapper)
    )
      return;
    (this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide")),
      this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
      (this.sliderControlLinksArray = Array.from(
        this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
      )),
      this.sliderControlLinksArray.forEach((e) =>
        e.addEventListener("click", this.linkToSlide.bind(this))
      ),
      this.slider.addEventListener(
        "scroll",
        this.setSlideVisibility.bind(this)
      ),
      this.setSlideVisibility(),
      "true" === this.slider.getAttribute("data-autoplay") &&
      this.setAutoPlay();
  }
  setAutoPlay() {
    (this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay")),
      (this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      ),
      this.addEventListener("mouseover", this.focusInHandling.bind(this)),
      this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
      this.addEventListener("focusin", this.focusInHandling.bind(this)),
      this.addEventListener("focusout", this.focusOutHandling.bind(this)),
      this.play(),
      (this.autoplayButtonIsSetToPlay = !0);
  }
  onButtonClick(e) {
    super.onButtonClick(e);
    let t = 1 === this.currentPage,
      i = this.currentPage === this.sliderItemsToShow.length;
    (t || i) &&
      (t && "previous" === e.currentTarget.name
        ? (this.slideScrollPosition =
          this.slider.scrollLeft +
          this.sliderFirstItemNode.clientWidth *
          this.sliderItemsToShow.length)
        : i &&
        "next" === e.currentTarget.name &&
        (this.slideScrollPosition = this.sliderFirstItemNode.clientWidth),
        this.slider.scrollTo({ left: this.slideScrollPosition }));
  }
  update() {
    super.update(),
      (this.sliderControlButtons = this.querySelectorAll(
        ".slider-counter__link"
      )),
      this.prevButton.removeAttribute("disabled"),
      this.sliderControlButtons.length &&
      (this.sliderControlButtons.forEach((e) => {
        e.classList.remove("slider-counter__link--active"),
          e.removeAttribute("aria-current");
      }),
        this.sliderControlButtons[this.currentPage - 1].classList.add(
          "slider-counter__link--active"
        ),
        this.sliderControlButtons[this.currentPage - 1].setAttribute(
          "aria-current",
          !0
        ));
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay);
  }
  focusOutHandling(e) {
    let t =
      e.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(e.target);
    this.autoplayButtonIsSetToPlay && !t && this.play();
  }
  focusInHandling(e) {
    let t =
      e.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(e.target);
    t && this.autoplayButtonIsSetToPlay
      ? this.play()
      : this.autoplayButtonIsSetToPlay && this.pause();
  }
  play() {
    this.slider.setAttribute("aria-live", "off"),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(
        this.autoRotateSlides.bind(this),
        this.autoplaySpeed
      ));
  }
  pause() {
    this.slider.setAttribute("aria-live", "polite"),
      clearInterval(this.autoplay);
  }
  togglePlayButtonState(e) {
    e
      ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.playSlideshow
        ))
      : (this.sliderAutoplayButton.classList.remove(
        "slideshow__autoplay--paused"
      ),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.pauseSlideshow
        ));
  }
  autoRotateSlides() {
    (this.slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
        this.slider.querySelector(".slideshow__slide").clientWidth),
      this.slider.scrollTo({ left: this.slideScrollPosition });
  }
  setSlideVisibility() {
    this.sliderItemsToShow.forEach((e, t) => {
      let i = e.querySelector("a");
      t === this.currentPage - 1
        ? (i && i.removeAttribute("tabindex"),
          e.setAttribute("aria-hidden", "false"),
          e.removeAttribute("tabindex"))
        : (i && i.setAttribute("tabindex", "-1"),
          e.setAttribute("aria-hidden", "true"),
          e.setAttribute("tabindex", "-1"));
    });
  }
  linkToSlide(e) {
    e.preventDefault(),
      (this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(e.currentTarget) +
          1 -
          this.currentPage)),
      this.slider.scrollTo({ left: this.slideScrollPosition });
  }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("change", this.onVariantChange),
      (this.productId = this.getAttribute("data-product")),
      (this.p_v_json = JSON.parse(
        $("#product-vi-json_" + this.productId).html()
      ));
  }
  onVariantChange() {
    this.checkData(),
      this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(!0, "", !1),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.updateSoldOut(),
      this.updateFieldsetText(),
      this.currentVariant
        ? (this.updateMedia(),
          this.updateFeaturedMedia(),
          this.updateURL(),
          this.updateVariantInput(),
          this.renderProductInfo(),
          this.updateShareUrl())
        : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
  }
  checkData() {
    (this.parentProduct = this.hasAttribute("data-parent")),
      (this.optionBase = this.dataset.base.split(",").length);
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (e) => e.value);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (e) => !e.options.map((e, t) => this.options[t] === e).includes(!1)
    );
  }
  updateMedia() {
    if (
      !this.currentVariant ||
      (!this.currentVariant.featured_media && !this.parentProduct)
    )
      return;
    let e = document.getElementById(`MediaGallery-${this.dataset.section}`),
      t = e.querySelector('[id^="GalleryViewer"]'),
      i = this.options.slice(0, this.optionBase).join(" / "),
      s = t.querySelectorAll(
        `[data-connect="${i}"]:not([data-feature="true"])`
      );
    if (s.length > 0)
      t.querySelectorAll("[data-connect]").forEach((e) => {
        e.classList.remove("product__media-item--variant_current");
      }),
        s.forEach((e) => {
          e.classList.add("product__media-item--variant_current");
        });
    else {
      e.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        !0
      );
      let o = document.querySelector(
        `#ProductModal-${this.dataset.section} .product-media-modal__content`
      );
      if (!o) return;
      let r = o.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
      o.prepend(r);
    }
    t.initPages();
  }
  updateFeaturedMedia() {
    if (!this.currentVariant) return;
    let e = document.querySelector("features-images");
    if (!e) return;
    e.querySelector('[id^="GalleryViewer"]');
    let t = e.querySelector('[id^="Slider-Gallery-"]'),
      i = document.getElementById(`MediaGallery-${this.dataset.section}`),
      s = i.querySelector('[id^="GalleryViewer"]'),
      o = this.options.slice(0, this.optionBase).join(" / "),
      r = s.querySelectorAll(`[data-connect="${o}"][data-feature="true"]`);
    t.innerHTML = "";
    var n = new Promise((e, i) => {
      r.forEach((i, s, o) => {
        let r = i.querySelector(".product__media").cloneNode(!0),
          n = document.createElement("li");
        n.classList.add("product__modal-opener--image", "slider__slide"),
          n.appendChild(r),
          t.appendChild(n),
          s === o.length - 1 && e();
      });
    });
    r.length > 0 && n.then(() => { });
  }
  updateURL() {
    this.currentVariant &&
      "false" !== this.dataset.updateUrl &&
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateShareUrl() {
    let e = document.getElementById(`Share-${this.dataset.section}`);
    e &&
      e.updateUrl &&
      e.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateSoldOut() {
    let e = Array.from(this.querySelectorAll("fieldset"));
    if (e) {
      (this.optionValues = e.map((e) =>
        "SELECT" === e.tagName
          ? e.value
          : Array.from(e.querySelectorAll("input")).find((e) => e.checked).value
      )),
        (this.firstOptionValue = this.firstOptionValue || this.optionValues[0]);
      for (var t = 1; t < e.length; t++)
        for (var i = e[t].querySelectorAll("input"), s = 0; s < i.length; s++)
          i[s].classList.add("disabled");
      this.options.forEach((t, i) => {
        var s = t,
          o = "option" + (i + 1),
          r = this.getVariantData().filter(function (e, t) {
            return e[o] == s;
          });
        0 == i &&
          r.forEach((t) => {
            t.available &&
              t.options.forEach((t, i) => {
                e[i]
                  .querySelector(`input[value="${t}"]`)
                  .classList.remove("disabled");
              });
          });
      });
    }
  }
  updateFieldsetText() {
    let e = this.options,
      t = this.querySelectorAll("fieldset");
    t.forEach((t, i) => {
      let s = t.querySelector("legend span");
      s.innerText = e[i];
    });
  }
  updateVariantInput() {
    let e = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    e.forEach((e) => {
      let t = e.querySelector('input[name="id"]');
      (t.value = this.currentVariant.id),
        t.dispatchEvent(new Event("change", { bubbles: !0 }));
    });
  }
  updatePickupAvailability() {
    let e = document.querySelector("pickup-availability");
    e &&
      (this.currentVariant && this.currentVariant.available
        ? e.fetchAvailability(this.currentVariant.id)
        : (e.removeAttribute("available"), (e.innerHTML = "")));
  }
  removeErrorMessage() {
    let e = this.closest("section");
    if (!e) return;
    let t = e.querySelector("product-form");
    t && t.handleErrorMessage();
  }
  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
    )
      .then((e) => e.text())
      .then((e) => {
        let t = new DOMParser().parseFromString(e, "text/html"),
          i = document.getElementById(`price-${this.dataset.section}`),
          s = t.getElementById(
            `price-${this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
            }`
          );
        s && i && (i.innerHTML = s.innerHTML);
        let o = document.getElementById(`price-${this.dataset.section}`);
        o && o.classList.remove("visibility-hidden"),
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
      });
  }
  toggleAddButton(e = !0, t, i = !0) {
    let s = document.getElementById(`product-form-${this.dataset.section}`);
    if (!s) return;
    let o = s.querySelector('[name="add"]'),
      r = s.querySelector('[name="add"] > span');
    if (o) {
      var n = this.p_v_json.variants.find(
        (e) => e.id == this.currentVariant.id
      );
      if (
        (e
          ? (o.setAttribute("disabled", "disabled"),
            t &&
            (n?.coming_soon
              ? (r.textContent = "Coming Soon")
              : (r.textContent = t)))
          : (o.removeAttribute("disabled"),
            (r.textContent = window.variantStrings.addToCart)),
          !i)
      )
        return;
    }
  }
  setUnavailable() {
    let e = document.getElementById(`product-form-${this.dataset.section}`),
      t = e.querySelector('[name="add"]'),
      i = e.querySelector('[name="add"] > span'),
      s = document.getElementById(`price-${this.dataset.section}`);
    t &&
      (console.log(variant_info.coming_soon),
        (i.textContent = window.variantStrings.unavailable),
        s && s.classList.add("visibility-hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
  removeAllChildNodes(e) {
    for (; e.firstChild;) e.removeChild(e.firstChild);
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  updateOptions() {
    let e = Array.from(this.querySelectorAll("fieldset"));
    this.options = e.map(
      (e) =>
        Array.from(e.querySelectorAll("input")).find((e) => e.checked).value
    );
  }
}
customElements.define("variant-radios", VariantRadios);
class TooltipOpener extends HTMLElement {
  constructor() {
    super(), new bootstrap.Tooltip(this);
  }
}
function serializeJSON(e) {
  let t = new FormData(e),
    i = {},
    s = {};
  for (let [o, r] of t)
    null !== r &&
      "" !== r &&
      "{}" !== JSON.stringify(r) &&
      ("form_type" == o || "utf8" == o ? (s[o] = r) : (i[o] = r));
  return JSON.stringify({ consistent: s, data: i }, null, 2);
}
customElements.define("tooltip-component", TooltipOpener);
class ApplyProcode extends HTMLElement {
  constructor() {
    super(),
      (this.procodeForm = document.getElementById("pro-code--form")),
      (this.container = document.getElementById("procode")),
      (this.thanks = document.getElementById("pro-code--thanks")),
      this.procodeForm.addEventListener("submit", this.procodeCheck.bind(this));
  }
  procodeCheck(e) {
    e.preventDefault();
    let t = e.target,
      i = t.querySelector("button"),
      s;
    this.hasAttribute("data-redirect") && (s = this.dataset.redirect),
      (i.disabled = !0),
      i.classList.add("button--loading"),
      fetch("https://hook.us1.make.com/95l6jr5qki6y4c8rxlys1yrai2o7dw47", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: serializeJSON(t),
      })
        .then((e) => e.json())
        .then((e) => {
          (i.disabled = !1), i.classList.remove("button--loading");
          var t = document.getElementById("form_error");
          t ||
            (((t = document.createElement("div")).id = "form_error"),
              i.parentNode.insertBefore(t, i.nextSibling)),
            e.success
              ? (this.form.classList.add("hidden"),
                this.thanks.classList.remove("hidden"),
                this.thanks.scrollIntoView(),
                s &&
                setTimeout(function () {
                  window.location.href = s;
                }, 500))
              : (t.innerText = e.reason);
        })
        .catch((e) => {
          console.error("Error:", e);
        });
  }
}
/*
 * @license Basictable - Vanilla JS | MIT | Jerry Low | https://www.github.com/jerrylow/basictable
 */ ("use strict");
customElements.define("apply-procode", ApplyProcode),
  (String.prototype.imgURL = function (e) {
    return this.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (t) {
      return "_" + e + t;
    });
  });
class basictable {
  constructor(e, t = {}) {
    (this.tableSel = e),
      (this.options = {
        breakpoint: null,
        containerBreakpoint: null,
        contentWrap: !0,
        forceResponsive: !0,
        noResize: !1,
        tableWrap: !1,
        showEmptyCells: !1,
        header: !0,
        ...t,
      }),
      null === this.options.breakpoint &&
      null === this.options.containerBreakpoint &&
      (this.options.breakpoint = 568),
      this._getTables(),
      this._setup();
  }
  _getTables() {
    this.tables = document.querySelectorAll(this.tableSel);
  }
  _setup() {
    this.tables.forEach((e) => {
      e.setAttribute("data-bt-active", !0);
      let t = [];
      if (this.options.tableWrap) {
        let i = document.createElement("div");
        i.classList.add("bt-wrapper"),
          e.parentNode.insertBefore(i, e),
          i.appendChild(e);
      }
      if (this.options.header) {
        let s = "";
        (s = e.querySelectorAll("thead tr th").length
          ? "thead th"
          : e.querySelectorAll("tbody tr th").length
            ? "tbody tr th"
            : e.querySelectorAll("th").length
              ? "tr:first th"
              : "tr:first td"),
          e.querySelectorAll(s).forEach((e) => {
            let i = parseInt(e.getAttribute("colspan"), 10) || 1,
              s = e.closest("tr"),
              o = [].indexOf.call(s.parentElement.children, s);
            t[o] || (t[o] = []);
            for (let r = 0; r < i; r++) t[o].push(e);
          }),
          e.querySelectorAll("tbody tr").forEach((e) => this._setupRow(e, t)),
          e.querySelectorAll("tfoot tr").forEach((e) => this._setupRow(e, t));
      }
      this.options.noResize || this._check(e);
    }),
      this.options.noResize ||
      ((this._tableResizeEvent = () => this._resize()),
        window.addEventListener("resize", this._tableResizeEvent));
  }
  _setupRow(e, t) {
    e.querySelectorAll(":scope > *").forEach((e) => {
      if (
        ("" === e.innerHTML.trim() || "&nbsp;" === e.innerHTML) &&
        this.options.showEmptyCells
      )
        e.classList("bt-hide");
      else {
        let i = [].indexOf.call(e.parentElement.children, e),
          s = "";
        for (let o = 0; o < t.length; o++)
          0 !== o && (s += ": "), (s += t[o][i].textContent);
        e.setAttribute("data-th", s);
        let r = document.createElement("span");
        if (
          (r.classList.add("bt-content"),
            this.options.contentWrap && e.firstChild !== r)
        )
          for (e.appendChild(r); e.firstChild !== r;)
            r.appendChild(e.firstChild);
      }
    });
  }
  _check(e) {
    this.options.forceResponsive
      ? (null !== this.options.breakpoint &&
        window.innerWidth <= this.options.breakpoint) ||
        (null !== this.options.containerBreakpoint &&
          e.parentElement.offsetWidth <= this.options.containerBreakpoint)
        ? this._start(e)
        : this._end(e)
      : (e.classList.remove("bt"),
        e.getBoundingClientRect().left + e.offsetWidth >
          e.parentElement.offsetWidth
          ? this._start(e)
          : this._end(e));
  }
  _start(e) {
    e.classList.add("bt"),
      this.options.header || e.classList.add("bt--no-header"),
      this.options.tableWrap &&
      e.closest(".bt-wrapper").classList.add("active");
  }
  _end(e) {
    e.classList.remove("bt", "bt--no-header"),
      this.options.tableWrap &&
      e.closest(".bt-wrapper").classList.remove("active");
  }
  _resize(e) {
    this.tables.forEach((e) => {
      e.getAttribute("data-bt-active") && this._check(e);
    });
  }
  start() {
    this.tables.forEach((e) => {
      this._start(e);
    });
  }
  stop() {
    this.tables.forEach((e) => {
      this._end(e);
    });
  }
  restart() {
    this.destroy(), this._getTables(), this._setup();
  }
  destroy() {
    this.tables.forEach((e) => {
      if (e.getAttribute("data-bt-active")) {
        e.classList.remove("bt", "bt--no-header"),
          e.removeAttribute("data-bt-active");
        let t = e.querySelectorAll("td");
        t.forEach((e) => e.removeAttribute("data-th")),
          this.options.contentWrap &&
          t.forEach((e) => {
            let t = e.querySelector(".bt-content");
            t && (e.innerHTML = t.innerHTML);
          }),
          this.options.tableWrap &&
          (e.parentNode.outerHTML = e.parentNode.innerHTML);
      }
    }),
      this.options.noResize ||
      window.removeEventListener("resize", this._tableResizeEvent);
  }
}
class SizeChart extends HTMLElement {
  constructor() {
    super();
  }
}
customElements.define("size-chart", SizeChart);
class FeaturesImages extends HTMLElement {
  constructor() {
    if (
      (super(),
        (this.selector = document.querySelector(
          `variant-selects[data-product="${this.dataset.product}"]`
        )),
        this.selector)
    )
      this.options = Array.from(
        this.selector.querySelectorAll("select"),
        (e) => e.value
      );
    else {
      this.selector = document.querySelector(
        `variant-radios[data-product="${this.dataset.product}"]`
      );
      let e = Array.from(this.selector.querySelectorAll("fieldset"));
      this.options = e.map(
        (e) =>
          Array.from(e.querySelectorAll("input")).find((e) => e.checked).value
      );
    }
    (this.parentProduct = this.selector.hasAttribute("data-parent")),
      (this.galleryEl = this.querySelector('[id^="GalleryViewer"]')),
      (this.slideshowEl = this.querySelector('[id^="Slider-Gallery-"]')),
      (this.optionBase = this.selector.dataset.base.split(",").length);
    let t = document.getElementById(
      `MediaGallery-${this.selector.dataset.section}`
    ),
      i = t.querySelector('[id^="GalleryViewer"]'),
      s = this.options.slice(0, this.optionBase).join(" / "),
      o = i.querySelectorAll(`[data-connect="${s}"][data-feature="true"]`);
    var r = new Promise((e, t) => {
      o.forEach((t, i, s) => {
        let o = t.querySelector(".product__media").cloneNode(!0),
          r = document.createElement("li");
        r.classList.add("product__modal-opener--image", "slider__slide"),
          r.appendChild(o),
          this.slideshowEl.appendChild(r),
          i === s.length - 1 && e();
      });
    });
    o.length > 0 &&
      r.then(() => {
        this.galleryEl.initPages();
      });
  }
}
customElements.define("features-images", FeaturesImages);
class ShopTheLookForm extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(!0, "", !1),
      this.removeErrorMessage(),
      this.currentVariant
        ? (this.updateMedia(),
          this.updateVariantInput(),
          this.renderProductInfo())
        : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select[name^="options"]'),
      (e) => e.value
    );
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (e) => !e.options.map((e, t) => this.options[t] === e).includes(!1)
    );
  }
  updateMedia() {
    let e = this.currentVariant.featured_image;
    if (!e) return;
    let t = this.closest(".row").querySelector(".media img"),
      i = e.src;
    t.removeAttribute("srcset"), (t.src = i.imgURL("750x"));
  }
  updateVariantInput() {
    let e = document.querySelectorAll(
      `#ProductFormShopTheLook-${this.dataset.section}`
    );
    e.forEach((e) => {
      let t = e.querySelector('input[name="id"]');
      (t.value = this.currentVariant.id),
        t.dispatchEvent(new Event("change", { bubbles: !0 }));
    });
  }
  removeErrorMessage() {
    let e = this.closest("section");
    if (!e) return;
    let t = e.querySelector("product-form");
    t && t.handleErrorMessage();
  }
  renderProductInfo() {
    let e = this.querySelector('select[name="product-change"]'),
      t = e ? e.options[e.selectedIndex].dataset.url : this.dataset.url;
    fetch(`${t}?variant=${this.currentVariant.id}`)
      .then((e) => e.text())
      .then((e) => {
        let t = new DOMParser().parseFromString(e, "text/html");
        (this.productElement = t.querySelector('section[id^="MainProduct-"]')),
          (this.sectionId = this.productElement.dataset.section);
        let i = document.getElementById(`price-${this.sectionId}`),
          s = t.getElementById(
            `price-${this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
            }`
          );
        s && i && (i.innerHTML = s.innerHTML);
        let o = document.getElementById(`price-${this.dataset.section}`);
        o && o.classList.remove("visibility-hidden"),
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
      });
  }
  toggleAddButton(e = !0, t, i = !0) {
    let s = document.getElementById(
      `ProductFormShopTheLook-${this.dataset.productid}`
    );
    if (!s) return;
    let o = s.querySelector('[name="add"]'),
      r = s.querySelector('[name="add"] > span');
    if (
      o &&
      (e
        ? (o.setAttribute("disabled", "disabled"), t && (r.textContent = t))
        : (o.removeAttribute("disabled"),
          (r.textContent = window.variantStrings.addToCart)),
        !i)
    )
      return;
  }
  setUnavailable() {
    let e = document.getElementById(
      `ProductFormShopTheLook-${this.dataset.productid}`
    ),
      t = e.querySelector('[name="add"]'),
      i = e.querySelector('[name="add"] > span'),
      s = document.getElementById(`price-${this.dataset.productid}`);
    t &&
      ((i.textContent = window.variantStrings.soldOut),
        s && s.classList.add("visibility-hidden"));
  }
  getVariantData() {
    let e = this.querySelector('select[name="product-change"]'),
      t = e
        ? e.options[e.selectedIndex].dataset.product
        : this.dataset.productid,
      i = this.closest(".shop-the-look__popup-content").querySelector(
        `[type="application/json"][data-productId="${t}"]`
      );
    return (this.variantData = JSON.parse(i.textContent)), this.variantData;
  }
}
customElements.define("shop-form", ShopTheLookForm);
class CollectionSlider extends HTMLElement {
  constructor() {
    if (
      (super(),
        (this.slider = this.querySelector(".grid--collection_slider")),
        (this.sliderItems = this.querySelectorAll(".grid__item_collection")),
        !this.slider || this.sliderItems.length < 2)
    )
      return;
    new Glider(this.slider, {
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: { prev: ".glider-prev", next: ".glider-next" },
    });
  }
}
customElements.define("collection-slider", CollectionSlider);
class CardSwitcher extends HTMLAnchorElement {
  constructor() {
    super(), this.addEventListener("click", this.colorSwitch);
  }
  colorSwitch(e) {
    let t = (e = window.event || e).target,
      i = this.querySelector(".card-mainimg"),
      s = this.querySelector(".card-hoverimg");
    if (t.classList.contains("card-variant")) {
      e.preventDefault();
      let o = t.dataset.id,
        r = this.href.split("?"),
        n = "",
        a = this.querySelectorAll(".card-information__variant-image");
      [].forEach.call(a, function (e) {
        e.classList.remove("current");
      }),
        t.closest(".card-information__variant-image").classList.add("current"),
        void 0 !== r[1] && (n = "&" + r[1]);
      let l = r[0] + "?variant=" + o + n;
      this.setAttribute("href", l);
      let d = this.src,
        c = t.dataset.featured;
      if (d != c) {
        let u = t.dataset.featuredsrcset,
          p = t.getAttribute("alt");
        i.setAttribute("src", c),
          i.setAttribute("srcset", u),
          i.setAttribute("alt", p);
        let h = t.dataset.hover;
        if ("" !== h) {
          let m = t.dataset.hoversrcset;
          s.setAttribute("src", h), s.setAttribute("srcset", m);
        }
      }
    }
  }
}
customElements.define("card-switcher", CardSwitcher, { extends: "a" }),
  // Featured Tabs: allow variant thumbnails to live outside the `card-switcher` anchor.
  // We delegate to the card wrapper and update the linked main image + `current` thumbnail state.
  document.addEventListener("click", function (e) {
    let t = (e = window.event || e).target;
    if (!t || !t.classList || !t.classList.contains("card-variant")) return;
    let i = t.closest(".card-wrapper--featured-tabs");
    if (!i) return;
    let s = i.querySelector('a[is="card-switcher"]');
    if (!s) return;
    // If the thumbnail is inside the `card-switcher` anchor, the element class handles it already.
    if (s.contains(t)) return;

    e.preventDefault();

    let o = t.dataset.id,
      r = s.href.split("?"),
      n = "",
      a = i.querySelectorAll(".card-information__variant-image");
    a && a.length
      ? [].forEach.call(a, function (e) {
          e.classList.remove("current");
        })
      : void 0;

    let l = t.closest(".card-information__variant-image");
    l && l.classList.add("current");

    void 0 !== r[1] && (n = "&" + r[1]);
    let d = r[0] + "?variant=" + o + n;
    s.setAttribute("href", d);

    let c = s.querySelector(".card-mainimg"),
      u = s.querySelector(".card-hoverimg"),
      p = t.dataset.featured,
      h = t.dataset.featuredsrcset,
      m = t.getAttribute("alt");
    c && p && c.getAttribute("src") !== p
      ? (c.setAttribute("src", p),
        h && c.setAttribute("srcset", h),
        m && c.setAttribute("alt", m))
      : void 0;

    let f = t.dataset.hover;
    if ("" !== f) {
      let g = t.dataset.hoversrcset;
      u &&
        (u.setAttribute("src", f),
        g && u.setAttribute("srcset", g));
    }
  }),
  (function (e, t) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = t())
      : "function" == typeof define && define.amd
        ? define(t)
        : ((e =
          "undefined" != typeof globalThis ? globalThis : e || self).jarallax =
          t());
  })(this, function () {
    "use strict";
    function e(e) {
      "complete" === document.readyState ||
        "interactive" === document.readyState
        ? e()
        : document.addEventListener("DOMContentLoaded", e, {
          capture: !0,
          once: !0,
          passive: !0,
        });
    }
    let t;
    var i = (t =
      "undefined" != typeof window
        ? window
        : "undefined" != typeof global
          ? global
          : "undefined" != typeof self
            ? self
            : {});
    let { navigator: s } = i,
      o = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        s.userAgent
      ),
      r,
      n;
    function a() {
      o
        ? (!r &&
          document.body &&
          (((r = document.createElement("div")).style.cssText =
            "position: fixed; top: -9999px; left: 0; height: 100vh; width: 0;"),
            document.body.appendChild(r)),
          (n =
            (r ? r.clientHeight : 0) ||
            i.innerHeight ||
            document.documentElement.clientHeight))
        : (n = i.innerHeight || document.documentElement.clientHeight);
    }
    a(),
      i.addEventListener("resize", a),
      i.addEventListener("orientationchange", a),
      i.addEventListener("load", a),
      e(() => {
        a();
      });
    let l = [];
    function d() {
      l.length &&
        (l.forEach((e, t) => {
          let { instance: s, oldData: o } = e,
            r = s.$item.getBoundingClientRect(),
            a = {
              width: r.width,
              height: r.height,
              top: r.top,
              bottom: r.bottom,
              wndW: i.innerWidth,
              wndH: n,
            },
            d =
              !o ||
              o.wndW !== a.wndW ||
              o.wndH !== a.wndH ||
              o.width !== a.width ||
              o.height !== a.height,
            c = d || !o || o.top !== a.top || o.bottom !== a.bottom;
          (l[t].oldData = a), d && s.onResize(), c && s.onScroll();
        }),
          i.requestAnimationFrame(d));
    }
    let c = 0;
    class u {
      constructor(e, t) {
        let i = this;
        (i.instanceID = c),
          (c += 1),
          (i.$item = e),
          (i.defaults = {
            type: "scroll",
            speed: 0.5,
            imgSrc: null,
            imgElement: ".jarallax-img",
            imgSize: "cover",
            imgPosition: "50% 50%",
            imgRepeat: "no-repeat",
            keepImg: !1,
            elementInViewport: null,
            zIndex: -100,
            disableParallax: !1,
            disableVideo: !1,
            videoSrc: null,
            videoStartTime: 0,
            videoEndTime: 0,
            videoVolume: 0,
            videoLoop: !0,
            videoPlayOnlyVisible: !0,
            videoLazyLoading: !0,
            onScroll: null,
            onInit: null,
            onDestroy: null,
            onCoverImage: null,
          });
        let o = i.$item.dataset || {},
          r = {};
        if (
          (Object.keys(o).forEach((e) => {
            let t = e.substr(0, 1).toLowerCase() + e.substr(1);
            t && void 0 !== i.defaults[t] && (r[t] = o[e]);
          }),
            (i.options = i.extend({}, i.defaults, r, t)),
            (i.pureOptions = i.extend({}, i.options)),
            Object.keys(i.options).forEach((e) => {
              "true" === i.options[e]
                ? (i.options[e] = !0)
                : "false" === i.options[e] && (i.options[e] = !1);
            }),
            (i.options.speed = Math.min(
              2,
              Math.max(-1, parseFloat(i.options.speed))
            )),
            "string" == typeof i.options.disableParallax &&
            (i.options.disableParallax = RegExp(i.options.disableParallax)),
            i.options.disableParallax instanceof RegExp)
        ) {
          let n = i.options.disableParallax;
          i.options.disableParallax = () => n.test(s.userAgent);
        }
        if (
          ("function" != typeof i.options.disableParallax &&
            (i.options.disableParallax = () => !1),
            "string" == typeof i.options.disableVideo &&
            (i.options.disableVideo = RegExp(i.options.disableVideo)),
            i.options.disableVideo instanceof RegExp)
        ) {
          let a = i.options.disableVideo;
          i.options.disableVideo = () => a.test(s.userAgent);
        }
        "function" != typeof i.options.disableVideo &&
          (i.options.disableVideo = () => !1);
        let l = i.options.elementInViewport;
        l && "object" == typeof l && void 0 !== l.length && ([l] = l),
          l instanceof Element || (l = null),
          (i.options.elementInViewport = l),
          (i.image = {
            src: i.options.imgSrc || null,
            $container: null,
            useImgTag: !1,
            position: "fixed",
          }),
          i.initImg() && i.canInitParallax() && i.init();
      }
      css(e, t) {
        return "string" == typeof t
          ? i.getComputedStyle(e).getPropertyValue(t)
          : (Object.keys(t).forEach((i) => {
            e.style[i] = t[i];
          }),
            e);
      }
      extend(e, ...t) {
        return (
          (e = e || {}),
          Object.keys(t).forEach((i) => {
            t[i] &&
              Object.keys(t[i]).forEach((s) => {
                e[s] = t[i][s];
              });
          }),
          e
        );
      }
      getWindowData() {
        return {
          width: i.innerWidth || document.documentElement.clientWidth,
          height: n,
          y: document.documentElement.scrollTop,
        };
      }
      initImg() {
        let e = this,
          t = e.options.imgElement;
        return (
          t && "string" == typeof t && (t = e.$item.querySelector(t)),
          t instanceof Element ||
          (e.options.imgSrc
            ? ((t = new Image()).src = e.options.imgSrc)
            : (t = null)),
          t &&
          (e.options.keepImg
            ? (e.image.$item = t.cloneNode(!0))
            : ((e.image.$item = t), (e.image.$itemParent = t.parentNode)),
            (e.image.useImgTag = !0)),
          !!e.image.$item ||
          (null === e.image.src &&
            ((e.image.src =
              "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"),
              (e.image.bgImage = e.css(e.$item, "background-image"))),
            !(!e.image.bgImage || "none" === e.image.bgImage))
        );
      }
      canInitParallax() {
        return !this.options.disableParallax();
      }
      init() {
        let e = this,
          t = {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            overflow: "hidden",
          },
          s = {
            pointerEvents: "none",
            transformStyle: "preserve-3d",
            backfaceVisibility: "hidden",
          };
        if (!e.options.keepImg) {
          let o = e.$item.getAttribute("style");
          if (
            (o && e.$item.setAttribute("data-jarallax-original-styles", o),
              e.image.useImgTag)
          ) {
            let r = e.image.$item.getAttribute("style");
            r && e.image.$item.setAttribute("data-jarallax-original-styles", r);
          }
        }
        if (
          ("static" === e.css(e.$item, "position") &&
            e.css(e.$item, { position: "relative" }),
            "auto" === e.css(e.$item, "z-index") && e.css(e.$item, { zIndex: 0 }),
            (e.image.$container = document.createElement("div")),
            e.css(e.image.$container, t),
            e.css(e.image.$container, { "z-index": e.options.zIndex }),
            "fixed" === this.image.position &&
            e.css(e.image.$container, {
              "-webkit-clip-path": "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
              "clip-path": "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            }),
            e.image.$container.setAttribute(
              "id",
              `jarallax-container-${e.instanceID}`
            ),
            e.$item.appendChild(e.image.$container),
            e.image.useImgTag
              ? (s = e.extend(
                {
                  "object-fit": e.options.imgSize,
                  "object-position": e.options.imgPosition,
                  "max-width": "none",
                },
                t,
                s
              ))
              : ((e.image.$item = document.createElement("div")),
                e.image.src &&
                (s = e.extend(
                  {
                    "background-position": e.options.imgPosition,
                    "background-size": e.options.imgSize,
                    "background-repeat": e.options.imgRepeat,
                    "background-image":
                      e.image.bgImage || `url("${e.image.src}")`,
                  },
                  t,
                  s
                ))),
            ("opacity" !== e.options.type &&
              "scale" !== e.options.type &&
              "scale-opacity" !== e.options.type &&
              1 !== e.options.speed) ||
            (e.image.position = "absolute"),
            "fixed" === e.image.position)
        ) {
          let n = (function (e) {
            let t = [];
            for (; null !== e.parentElement;)
              1 === (e = e.parentElement).nodeType && t.push(e);
            return t;
          })(e.$item).filter((e) => {
            let t = i.getComputedStyle(e),
              s = t["-webkit-transform"] || t["-moz-transform"] || t.transform;
            return (
              (s && "none" !== s) ||
              /(auto|scroll)/.test(
                t.overflow + t["overflow-y"] + t["overflow-x"]
              )
            );
          });
          e.image.position = n.length ? "absolute" : "fixed";
        }
        (s.position = e.image.position),
          e.css(e.image.$item, s),
          e.image.$container.appendChild(e.image.$item),
          e.onResize(),
          e.onScroll(!0),
          e.options.onInit && e.options.onInit.call(e),
          "none" !== e.css(e.$item, "background-image") &&
          e.css(e.$item, { "background-image": "none" }),
          e.addToParallaxList();
      }
      addToParallaxList() {
        l.push({ instance: this }),
          1 === l.length && i.requestAnimationFrame(d);
      }
      removeFromParallaxList() {
        let e = this;
        l.forEach((t, i) => {
          t.instance.instanceID === e.instanceID && l.splice(i, 1);
        });
      }
      destroy() {
        this.removeFromParallaxList();
        let e = this.$item.getAttribute("data-jarallax-original-styles");
        if (
          (this.$item.removeAttribute("data-jarallax-original-styles"),
            e
              ? this.$item.setAttribute("style", e)
              : this.$item.removeAttribute("style"),
            this.image.useImgTag)
        ) {
          let t = this.image.$item.getAttribute(
            "data-jarallax-original-styles"
          );
          this.image.$item.removeAttribute("data-jarallax-original-styles"),
            t
              ? this.image.$item.setAttribute("style", e)
              : this.image.$item.removeAttribute("style"),
            this.image.$itemParent &&
            this.image.$itemParent.appendChild(this.image.$item);
        }
        this.image.$container &&
          this.image.$container.parentNode.removeChild(this.image.$container),
          this.options.onDestroy && this.options.onDestroy.call(this),
          delete this.$item.jarallax;
      }
      clipContainer() { }
      coverImage() {
        let e = this,
          t = e.image.$container.getBoundingClientRect(),
          i = t.height,
          { speed: s } = e.options,
          o =
            "scroll" === e.options.type || "scroll-opacity" === e.options.type,
          r = 0,
          a = i,
          l = 0;
        return (
          o &&
          (0 > s
            ? ((r = s * Math.max(i, n)), n < i && (r -= s * (i - n)))
            : (r = s * (i + n)),
            1 < s
              ? (a = Math.abs(r - n))
              : 0 > s
                ? (a = r / s + Math.abs(r))
                : (a += (n - i) * (1 - s)),
            (r /= 2)),
          (e.parallaxScrollDistance = r),
          (l = o ? (n - a) / 2 : (i - a) / 2),
          e.css(e.image.$item, {
            height: `${a}px`,
            marginTop: `${l}px`,
            left: "fixed" === e.image.position ? `${t.left}px` : "0",
            width: `${t.width}px`,
          }),
          e.options.onCoverImage && e.options.onCoverImage.call(e),
          { image: { height: a, marginTop: l }, container: t }
        );
      }
      isVisible() {
        return this.isElementInViewport || !1;
      }
      onScroll(e) {
        let t = this,
          s = t.$item.getBoundingClientRect(),
          o = s.top,
          r = s.height,
          a = {},
          l = s;
        if (
          (t.options.elementInViewport &&
            (l = t.options.elementInViewport.getBoundingClientRect()),
            (t.isElementInViewport =
              0 <= l.bottom &&
              0 <= l.right &&
              l.top <= n &&
              l.left <= i.innerWidth),
            !e && !t.isElementInViewport)
        )
          return;
        let d = Math.max(0, r + o),
          c = Math.max(0, -o),
          u = Math.max(0, o + r - n),
          p = Math.max(0, r - (o + r - n)),
          h = Math.max(0, -o + n - r),
          m = 1 - ((n - o) / (n + r)) * 2,
          f = 1;
        if (
          (r < n
            ? (f = 1 - (c || u) / r)
            : d <= n
              ? (f = d / n)
              : p <= n && (f = p / n),
            ("opacity" !== t.options.type &&
              "scale-opacity" !== t.options.type &&
              "scroll-opacity" !== t.options.type) ||
            ((a.transform = "translate3d(0,0,0)"), (a.opacity = f)),
            "scale" === t.options.type || "scale-opacity" === t.options.type)
        ) {
          let g = 1;
          0 > t.options.speed
            ? (g -= t.options.speed * f)
            : (g += t.options.speed * (1 - f)),
            (a.transform = `scale(${g}) translate3d(0,0,0)`);
        }
        if (
          "scroll" === t.options.type ||
          "scroll-opacity" === t.options.type
        ) {
          let y = t.parallaxScrollDistance * m;
          "absolute" === t.image.position && (y -= o),
            (a.transform = `translate3d(0,${y}px,0)`);
        }
        t.css(t.image.$item, a),
          t.options.onScroll &&
          t.options.onScroll.call(t, {
            section: s,
            beforeTop: Math.max(0, o),
            beforeTopEnd: d,
            afterTop: c,
            beforeBottom: u,
            beforeBottomEnd: p,
            afterBottom: h,
            visiblePercent: f,
            fromViewportCenter: m,
          });
      }
      onResize() {
        this.coverImage();
      }
    }
    let p = function (e, t, ...i) {
      ("object" == typeof HTMLElement
        ? e instanceof HTMLElement
        : e &&
        "object" == typeof e &&
        null !== e &&
        1 === e.nodeType &&
        "string" == typeof e.nodeName) && (e = [e]);
      let s = e.length,
        o,
        r = 0;
      for (; r < s; r += 1)
        if (
          ("object" == typeof t || void 0 === t
            ? e[r].jarallax || (e[r].jarallax = new u(e[r], t))
            : e[r].jarallax && (o = e[r].jarallax[t].apply(e[r].jarallax, i)),
            void 0 !== o)
        )
          return o;
      return e;
    };
    p.constructor = u;
    let h = i.jQuery;
    if (void 0 !== h) {
      let m = function (...e) {
        Array.prototype.unshift.call(e, this);
        let t = p.apply(i, e);
        return "object" != typeof t ? t : this;
      };
      m.constructor = p.constructor;
      let f = h.fn.jarallax;
      (h.fn.jarallax = m),
        (h.fn.jarallax.noConflict = function () {
          return (h.fn.jarallax = f), this;
        });
    }
    return (
      e(() => {
        p(document.querySelectorAll("[data-jarallax]"));
      }),
      p
    );
  }),
  jarallax(document.querySelectorAll(".jarallax"), { speed: 0.2 }),
  (window.theme = window.theme || {}),
  (theme.Images = {
    preload: function e(t, i) {
      "string" == typeof t && (t = [t]);
      for (var s = 0; s < t.length; s++) {
        var o = t[s];
        this.loadImage(this.getSizedImageUrl(o, i));
      }
    },
    loadImage: function e(t) {
      new Image().src = t;
    },
    switchImage: function e(t, i, s) {
      var o = this.imageSize(i.src),
        r = this.getSizedImageUrl(t.src, o);
      s ? s(r, t, i) : (i.src = r);
    },
    imageSize: function e(t) {
      var i = t.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );
      return null !== i ? i[1] : null;
    },
    getSizedImageUrl: function e(t, i) {
      if (null == i) return t;
      if ("master" === i) return this.removeProtocol(t);
      var s = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (null != s) {
        var o = t.split(s[0]),
          r = s[0];
        return this.removeProtocol(o[0] + "_" + i + r);
      }
      return null;
    },
    removeProtocol: function e(t) {
      return t.replace(/http(s)?:/, "");
    },
  }),
  (theme.Currency = {
    formatMoney: function e(t, i) {
      "string" == typeof t && (t = t.replace(".", ""));
      const currencyCode = Shopify.currency.active;
      const symbolDiv = document.querySelector('.price-item.price-item--regular');
      let currencySymbol = '$';

      if (symbolDiv) {
        const text = symbolDiv.textContent.trim();
        // Extract the first non-digit, non-space character(s) as the symbol
        currencySymbol = text.match(/[^\d\s]+/)[0];
      }
      var s = "",
        o = /\{\{\s*(\w+)\s*\}\}/,
        r = i || currencySymbol + '' + "{{amount}}" + ' ' + currencyCode;
      console.log('Amount', r);
      function n(e, t, i, s) {
        if (
          ((t = t || 2), (i = i || ","), (s = s || "."), isNaN(e) || null == e)
        )
          return 0;
        var o,
          r = (e = (e / 100).toFixed(t)).split(".");
        return (
          r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
          (r[1] ? s + r[1] : "")
        );
      }
      switch (r.match(o)[1]) {
        case "amount":
          s = n(t, 2);
          break;
        case "amount_no_decimals":
          s = n(t, 0);
          break;
        case "amount_with_comma_separator":
          s = n(t, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          s = n(t, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          s = n(t, 0, " ");
      }
      return r.replace(o, s);
    },
  }),
  $(document).ready(function () {
    $(".js-quick-shop").each(function () {
      $("body").append($(this));
    }),
      $(".js-quick-shop-cta").on("click", function () {
        var e = $(this).attr("data-trigger");
        var $qs = $(e);
        $qs.fadeIn();
        setTimeout(function () {
          if (!$qs.is(":visible")) return;
          var $visibleColorContainers = $qs.find(".quick-shop--input-color:visible");
          var $checkedColor = $qs.find('.quick-shop--input-color input[type="radio"]:checked');

          if ($checkedColor.length > 0) {
            var $checkedColorContainer = $checkedColor.closest(".quick-shop--input-color");
            if ($checkedColorContainer.length === 0 || !$checkedColorContainer.is(":visible")) {
              var $firstVisibleColorInput = $visibleColorContainers.first().find('input[type="radio"]');
              if ($firstVisibleColorInput.length > 0) {
                $firstVisibleColorInput.prop("checked", true).trigger("change");
                return;
              }
            }
          } else if ($visibleColorContainers.length > 0) {
            var $firstColorInput = $visibleColorContainers.first().find('input[type="radio"]');
            if ($firstColorInput.length > 0) {
              $firstColorInput.prop("checked", true).trigger("change");
              return;
            }
          }

          var $checked = $qs.find(".quick-shop__input input:checked");
          if ($checked.length) {
            $checked.first().trigger("change");
          }
        }, 150);
      }),
      $("body").on("click", ".js-qs-close", function () {
        $(".js-quick-shop").hide();
      }),
      $(document).mouseup(function (e) {
        var t = $(".quick-shop-popup");
        t.is(e.target) ||
          0 !== t.has(e.target).length ||
          $(".js-quick-shop").hide();
      }),
      $("body").on("change", ".quick-shop__input input", function () {
        var e = [],
          t = $(this).closest(".js-quick-shop").attr("data-product-id"),
          i = $(this).closest(".js-quick-shop");
        $(this).closest(".js-quick-shop").find(".quick-shop__input input:checked").each(function () {
          e.push($(this).val());
        });
        var s = JSON.parse($("#quick-shop-json_" + t).html()),
          o = JSON.parse($("#quick-shop-vi-json_" + t).html()),
          $allOptionGroups = i.find(".quick-shop__input"),
          changedGroupIndex = $allOptionGroups.index($(this).closest(".quick-shop__input"));
        if (changedGroupIndex < 0) {
          changedGroupIndex = 0;
        }

        var exact = s.find(function (t) {
          return (
            t.options &&
            e.length === t.options.length &&
            t.options.every(function (opt, j) {
              return e[j] === opt;
            })
          );
        });
        var candidates = s.filter(function (v) {
          return v.options && v.options[changedGroupIndex] === e[changedGroupIndex];
        });
        var r;
        if (exact) {
          r = exact;
        } else {
          r =
            candidates.find(function (v) {
              return (
                v.available &&
                v.options.every(function (opt, j) {
                  return j === changedGroupIndex || e[j] === opt;
                })
              );
            }) ||
            candidates.find(function (v) { return v.available; }) ||
            candidates[0];
        }

        // Keep radios + e aligned to resolved variant (fixes wrong size when color is option2, or after OOS fallback)
        if (r && r.options && r.options.length) {
          $allOptionGroups.each(function (groupIndex) {
            var wantVal = r.options[groupIndex];
            $(this).find("input[type='radio']").each(function () {
              $(this).prop("checked", $(this).val() === wantVal);
            });
          });
          e = r.options.slice();
        }

        // Update availability + disabled states for every option group (must run after fallback + e sync)
        $allOptionGroups.each(function (groupIndex) {
          var $group = $(this);
          $group.find("input").each(function () {
            var $input = $(this);
            var val = $input.val();
            var matchingVariants = s.filter(function (v) {
              return v.options && v.options.every(function (optVal, j) {
                return j === groupIndex ? true : e[j] === optVal;
              });
            });
            var variantsForVal = matchingVariants.filter(function (v) {
              return v.options && v.options[groupIndex] === val;
            });
            var isPossible = variantsForVal.length > 0;
            if (!isPossible) {
              $input.next().show();
              $input.addClass("disabled");
              $input.attr("data-avail", "soldout");
              return;
            }
            $input.next().show();
            var anyAvailable = variantsForVal.some(function (v) { return !!v.available; });
            $input.attr("data-avail", anyAvailable ? "available" : "soldout");
            var best = variantsForVal.find(function (v) { return !!v.available; }) || variantsForVal[0];
            if (best) $input.attr("data-vid", "custom--" + best.id);
            if (!anyAvailable) $input.addClass("disabled");
            else $input.removeClass("disabled");
          });
        });
        n = o.variants.find(function (x) { return x.id == r?.id; });

        if (r) {
          $(this).closest(".quick-shop-form").find('input[name="id"]').val(r.id);
          $(this).closest(".quick-shop-popup").find(".product__price-cell").html(
            theme.Currency.formatMoney(r.price, theme.moneyFormat).replace(".00", "")
          );

          if (r.compare_at_price > r.price) {
            $(this).closest(".quick-shop-popup").find(".compare__price-cell").html(
              theme.Currency.formatMoney(r.compare_at_price, theme.moneyFormat).replace(".00", "")
            ).removeClass("hide");
            $(this).closest(".quick-shop-popup").find(".product-price__price").addClass("product-price__sale product-price__sale--single");
          } else {
            $(this).closest(".quick-shop-popup").find(".compare__price-cell").addClass("hide");
            $(this).closest(".quick-shop-popup").find(".product-price__sale-label").addClass("hide");
            $(this).closest(".quick-shop-popup").find(".product-price__price").removeClass("product-price__sale product-price__sale--single");
          }
          var $form = $(this).closest('form');
          var productId = $form.data('section');
          var variantId = $(this).closest(".quick-shop-form").find('input[name="id"]').val();

          // Find matching option inside the select and mark it selected
          var $select = $form.find('#ProductSelect-' + productId);
          $select.val(variantId).trigger('change');

          let $selected = $select.find('option:selected');

          // var qsImgSrc =
          //   (r.featured_image && r.featured_image.src) ||
          //   $selected.attr("data-image-src");
          // if (qsImgSrc) {
          //   var qsImgSized = theme.Images.getSizedImageUrl(qsImgSrc, "350x") || qsImgSrc;
          //   i.find(".qs-popup-img-wrap img").removeAttr("srcset").attr("src", qsImgSized);
          // }

          // --- Metafields ---
          let discontinued = $selected.data('discontinued');
          let comingSoon = $selected.data('coming-soon');
          let soldOut = $selected.data('soldout');
          let invQty = Number($selected.data('inventory_quantity') || r.inventory_quantity || 0);
          let inventoryPolicy = $selected.data('inventory_policy') || r.inventory_policy;

          let variantAvailable = false;
          if (comingSoon === true || comingSoon === 'true') {
            variantAvailable = false;
          } else if ((soldOut === true || soldOut === 'true') && invQty <= 0 && inventoryPolicy !== 'continue') {
            variantAvailable = false;
          } else if (r.available || invQty > 0 || inventoryPolicy === 'continue') {
            variantAvailable = true;
          }

          // 🔹 Variant-level preorder
          let preorderEnabled = $select.data('preorder-enabled');
          let preorderDate = $select.data('preorder-date');
          let preorderQty = Number($select.data('preorder-quantity') || 0);

          // 🔹 Product-level fallback
          if (preorderEnabled === undefined || preorderEnabled === '') preorderEnabled = $selected.data('preorder-enabled');
          if (preorderDate === undefined || preorderDate === '') preorderDate = $selected.data('preorder-date');
          if (preorderQty === 0 || preorderQty === undefined) preorderQty = Number($selected.data('preorder-quantity') || 0);

          // --- Button elements ---
          const $btn = $form.find('.js-quick-shop-add-to-cart');
          const $btnText = $btn.find('span');
          const $preBtn = $form.find('.btn--preorder-info');
          const $preMsg = $form.find('.preorder-message');
          const now = new Date();
          const preorderDeadline = preorderDate ? new Date(preorderDate) : null;

          function updateBtn(state, text) {
            $btn.prop('disabled', state);
            $btnText.text(text);
          }

          // Reset all before applying logic
          $form.find('input[name="properties[Preorder]"]').val('').prop('disabled', true);
          $form.find('input[name="properties[_preorderActive]"]').val('').prop('disabled', true);
          $preMsg.hide();
          $preBtn.hide();
          $btn.show();

          // -------------------------
          // 1️⃣ PREORDER LOGIC
          // -------------------------
          if (preorderEnabled === true || preorderEnabled === 'true') {
            const absInventory = Math.abs(invQty);
            const preorderLimitReached = absInventory >= preorderQty;

            // 1️⃣ Before preorder date → preorder active
            if (preorderDeadline && preorderDeadline > now) {
              if (!preorderLimitReached) {
                $preBtn.show();
                $btn.hide();
                $preMsg.show();
                let pretext = $form.find('input[name="properties[Preorder]"]').data('val');
                $form.find('input[name="properties[Preorder]"]').val(pretext).removeAttr('disabdled').prop('disabled', false);
                $form.find('input[name="properties[_preorderActive]"]').val(true).removeAttr('disabdled').prop('disabled', false);
                updateBtn(false, 'PRE-ORDER NOW');
              } else if (variantAvailable) {
                updateBtn(false, 'ADD TO CART');
              } else {
                updateBtn(true, 'SOLD OUT');
              }
              return;
            }

            // 2️⃣ After preorder date → normal PDP
            if (preorderDeadline && preorderDeadline <= now) {
              if (preorderLimitReached) {
                updateBtn(true, 'SOLD OUT');
              } else if (comingSoon) {
                updateBtn(true, 'COMING SOON');
              } else {
                updateBtn(false, 'ADD TO CART');
              }
              return;
            }

            // 3️⃣ Fallback safety check
            if (!preorderDeadline) {
              if (!preorderLimitReached && invQty <= 0) {
                $preBtn.show();
                $btn.hide();
                $preMsg.show();
                updateBtn(false, 'PRE-ORDER NOW');
              } else {
                updateBtn(true, 'SOLD OUT');
              }
              return;
            }
          }

          // -------------------------
          // 2️⃣ Normal product logic
          // -------------------------
          if (comingSoon === true || comingSoon === 'true') {
            updateBtn(true, 'COMING SOON');
          } else if ((soldOut === true || soldOut === 'true') && invQty <= 0 && inventoryPolicy !== 'continue') {
            updateBtn(true, discontinued || 'SOLD OUT');
          } else if (!variantAvailable) {
            updateBtn(true, discontinued || 'SOLD OUT');
          } else {
            updateBtn(false, 'ADD TO CART');
          }




          $(this).closest(".quick-shop-form").find(".BIS_trigger").attr("data-variant-id", r.id);
        } else {
          $(this).closest(".quick-shop-form").find("button.js-quick-shop-add-to-cart").addClass("disabled").attr("disabled", "disabled");
          if (n?.coming_soon) {
            $(this).closest(".quick-shop-form").find("button.js-quick-shop-add-to-cart span").text("COMING SOON");
          } else {
            $(this).closest(".quick-shop-form").find("button.js-quick-shop-add-to-cart span").text("Unavailable");
          }
        }

        if (r.featured_image) {
          let a = theme.Images.getSizedImageUrl(r.featured_image.src, "350x");
          i.find(".qs-popup-img-wrap img").removeAttr("srcset");
          i.find(".qs-popup-img-wrap img").attr("src", a);
        }

      }),
      $("body").on("click", ".js-cp-close", function (e) {
        e.preventDefault(), $(".js-clearance-popup").hide();
      });
  }),
  (function (e) {
    "function" == typeof define && define.amd
      ? define(["jquery"], e)
      : e(
        "object" == typeof exports
          ? require("jquery")
          : window.jQuery || window.Zepto
      );
  })(function (e) {
    var t,
      i,
      s,
      o,
      r,
      n,
      a = "Close",
      l = "BeforeClose",
      d = "MarkupParse",
      c = "Open",
      u = "Change",
      p = ".mfp",
      h = "mfp-ready",
      m = "mfp-removing",
      f = "mfp-prevent-close",
      g = function () { },
      y = !!window.jQuery,
      v = e(window),
      b = function (e, i) {
        t.ev.on("mfp" + e + p, i);
      },
      S = function (t, i, s, o) {
        var r = document.createElement("div");
        return (
          (r.className = "mfp-" + t),
          s && (r.innerHTML = s),
          o ? i && i.appendChild(r) : ((r = e(r)), i && r.appendTo(i)),
          r
        );
      },
      E = function (i, s) {
        t.ev.triggerHandler("mfp" + i, s),
          t.st.callbacks &&
          ((i = i.charAt(0).toLowerCase() + i.slice(1)),
            t.st.callbacks[i] &&
            t.st.callbacks[i].apply(t, e.isArray(s) ? s : [s]));
      },
      C = function (i) {
        return (
          (i === n && t.currTemplate.closeBtn) ||
          ((t.currTemplate.closeBtn = e(
            t.st.closeMarkup.replace("%title%", t.st.tClose)
          )),
            (n = i)),
          t.currTemplate.closeBtn
        );
      },
      x = function () {
        e.magnificPopup.instance ||
          ((t = new g()).init(), (e.magnificPopup.instance = t));
      },
      I = function () {
        var e = document.createElement("p").style,
          t = ["ms", "O", "Moz", "Webkit"];
        if (void 0 !== e.transition) return !0;
        for (; t.length;) if (t.pop() + "Transition" in e) return !0;
        return !1;
      };
    (g.prototype = {
      constructor: g,
      init: function () {
        var i = navigator.appVersion;
        (t.isLowIE = t.isIE8 = document.all && !document.addEventListener),
          (t.isAndroid = /android/gi.test(i)),
          (t.isIOS = /iphone|ipad|ipod/gi.test(i)),
          (t.supportsTransition = I()),
          (t.probablyMobile =
            t.isAndroid ||
            t.isIOS ||
            /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(
              navigator.userAgent
            )),
          (s = e(document)),
          (t.popupsCache = {});
      },
      open: function (i) {
        if (!1 === i.isObj) {
          (t.items = i.items.toArray()), (t.index = 0);
          var o,
            n,
            a = i.items;
          for (o = 0; o < a.length; o++)
            if (((n = a[o]).parsed && (n = n.el[0]), n === i.el[0])) {
              t.index = o;
              break;
            }
        } else
          (t.items = e.isArray(i.items) ? i.items : [i.items]),
            (t.index = i.index || 0);
        if (t.isOpen) return void t.updateItemHTML();
        (t.types = []),
          (r = ""),
          i.mainEl && i.mainEl.length ? (t.ev = i.mainEl.eq(0)) : (t.ev = s),
          i.key
            ? (t.popupsCache[i.key] || (t.popupsCache[i.key] = {}),
              (t.currTemplate = t.popupsCache[i.key]))
            : (t.currTemplate = {}),
          (t.st = e.extend(!0, {}, e.magnificPopup.defaults, i)),
          (t.fixedContentPos =
            "auto" === t.st.fixedContentPos
              ? !t.probablyMobile
              : t.st.fixedContentPos),
          t.st.modal &&
          ((t.st.closeOnContentClick = !1),
            (t.st.closeOnBgClick = !1),
            (t.st.showCloseBtn = !1),
            (t.st.enableEscapeKey = !1)),
          t.bgOverlay ||
          ((t.bgOverlay = S("bg").on("click" + p, function () {
            t.close();
          })),
            (t.wrap = S("wrap")
              .attr("tabindex", -1)
              .on("click" + p, function (e) {
                t._checkIfClose(e.target) && t.close();
              })),
            (t.container = S("container", t.wrap))),
          (t.contentContainer = S("content")),
          t.st.preloader &&
          (t.preloader = S("preloader", t.container, t.st.tLoading));
        var l = e.magnificPopup.modules;
        for (o = 0; o < l.length; o++) {
          var u = l[o];
          t["init" + (u = u.charAt(0).toUpperCase() + u.slice(1))].call(t);
        }
        E("BeforeOpen"),
          t.st.showCloseBtn &&
          (t.st.closeBtnInside
            ? (b(d, function (e, t, i, s) {
              i.close_replaceWith = C(s.type);
            }),
              (r += " mfp-close-btn-in"))
            : t.wrap.append(C())),
          t.st.alignTop && (r += " mfp-align-top"),
          t.fixedContentPos
            ? t.wrap.css({
              overflow: t.st.overflowY,
              overflowX: "hidden",
              overflowY: t.st.overflowY,
            })
            : t.wrap.css({ top: v.scrollTop(), position: "absolute" }),
          (!1 !== t.st.fixedBgPos &&
            ("auto" !== t.st.fixedBgPos || t.fixedContentPos)) ||
          t.bgOverlay.css({ height: s.height(), position: "absolute" }),
          t.st.enableEscapeKey &&
          s.on("keyup" + p, function (e) {
            27 === e.keyCode && t.close();
          }),
          v.on("resize" + p, function () {
            t.updateSize();
          }),
          t.st.closeOnContentClick || (r += " mfp-auto-cursor"),
          r && t.wrap.addClass(r);
        var m = (t.wH = v.height()),
          f = {};
        if (t.fixedContentPos && t._hasScrollBar(m)) {
          var g = t._getScrollbarSize();
          g && (f.marginRight = g);
        }
        t.fixedContentPos &&
          (t.isIE7
            ? e("body, html").css("overflow", "hidden")
            : (f.overflow = "hidden"));
        var y = t.st.mainClass;
        return (
          t.isIE7 && (y += " mfp-ie7"),
          y && t._addClassToMFP(y),
          t.updateItemHTML(),
          E("BuildControls"),
          e("html").css(f),
          t.bgOverlay.add(t.wrap).prependTo(t.st.prependTo || e(document.body)),
          (t._lastFocusedEl = document.activeElement),
          setTimeout(function () {
            t.content
              ? (t._addClassToMFP(h), t._setFocus())
              : t.bgOverlay.addClass(h),
              s.on("focusin" + p, t._onFocusIn);
          }, 16),
          (t.isOpen = !0),
          t.updateSize(m),
          E(c),
          i
        );
      },
      close: function () {
        t.isOpen &&
          (E(l),
            (t.isOpen = !1),
            t.st.removalDelay && !t.isLowIE && t.supportsTransition
              ? (t._addClassToMFP(m),
                setTimeout(function () {
                  t._close();
                }, t.st.removalDelay))
              : t._close());
      },
      _close: function () {
        E(a);
        var i = m + " " + h + " ";
        if (
          (t.bgOverlay.detach(),
            t.wrap.detach(),
            t.container.empty(),
            t.st.mainClass && (i += t.st.mainClass + " "),
            t._removeClassFromMFP(i),
            t.fixedContentPos)
        ) {
          var o = { marginRight: "" };
          t.isIE7 ? e("body, html").css("overflow", "") : (o.overflow = ""),
            e("html").css(o);
        }
        s.off("keyup" + p + " focusin" + p),
          t.ev.off(p),
          t.wrap.attr("class", "mfp-wrap").removeAttr("style"),
          t.bgOverlay.attr("class", "mfp-bg"),
          t.container.attr("class", "mfp-container"),
          !t.st.showCloseBtn ||
          (t.st.closeBtnInside && !0 !== t.currTemplate[t.currItem.type]) ||
          (t.currTemplate.closeBtn && t.currTemplate.closeBtn.detach()),
          t.st.autoFocusLast && t._lastFocusedEl && e(t._lastFocusedEl).focus(),
          (t.currItem = null),
          (t.content = null),
          (t.currTemplate = null),
          (t.prevHeight = 0),
          E("AfterClose");
      },
      updateSize: function (e) {
        if (t.isIOS) {
          var i = document.documentElement.clientWidth / window.innerWidth,
            s = window.innerHeight * i;
          t.wrap.css("height", s), (t.wH = s);
        } else t.wH = e || v.height();
        t.fixedContentPos || t.wrap.css("height", t.wH), E("Resize");
      },
      updateItemHTML: function () {
        var i = t.items[t.index];
        t.contentContainer.detach(),
          t.content && t.content.detach(),
          i.parsed || (i = t.parseEl(t.index));
        var s = i.type;
        if (
          (E("BeforeChange", [t.currItem ? t.currItem.type : "", s]),
            (t.currItem = i),
            !t.currTemplate[s])
        ) {
          var r = !!t.st[s] && t.st[s].markup;
          E("FirstMarkupParse", r),
            r ? (t.currTemplate[s] = e(r)) : (t.currTemplate[s] = !0);
        }
        o && o !== i.type && t.container.removeClass("mfp-" + o + "-holder");
        var n = t["get" + s.charAt(0).toUpperCase() + s.slice(1)](
          i,
          t.currTemplate[s]
        );
        t.appendContent(n, s),
          (i.preloaded = !0),
          E(u, i),
          (o = i.type),
          t.container.prepend(t.contentContainer),
          E("AfterChange");
      },
      appendContent: function (e, i) {
        (t.content = e),
          e
            ? t.st.showCloseBtn &&
              t.st.closeBtnInside &&
              !0 === t.currTemplate[i]
              ? t.content.find(".mfp-close").length || t.content.append(C())
              : (t.content = e)
            : (t.content = ""),
          E("BeforeAppend"),
          t.container.addClass("mfp-" + i + "-holder"),
          t.contentContainer.append(t.content);
      },
      parseEl: function (i) {
        var s,
          o = t.items[i];
        if (
          (o.tagName
            ? (o = { el: e(o) })
            : ((s = o.type), (o = { data: o, src: o.src })),
            o.el)
        ) {
          for (var r = t.types, n = 0; n < r.length; n++)
            if (o.el.hasClass("mfp-" + r[n])) {
              s = r[n];
              break;
            }
          (o.src = o.el.attr("data-mfp-src")),
            o.src || (o.src = o.el.attr("href"));
        }
        return (
          (o.type = s || t.st.type || "inline"),
          (o.index = i),
          (o.parsed = !0),
          (t.items[i] = o),
          E("ElementParse", o),
          t.items[i]
        );
      },
      addGroup: function (e, i) {
        var s = function (s) {
          (s.mfpEl = this), t._openClick(s, e, i);
        };
        i || (i = {});
        var o = "click.magnificPopup";
        (i.mainEl = e),
          i.items
            ? ((i.isObj = !0), e.off(o).on(o, s))
            : ((i.isObj = !1),
              i.delegate
                ? e.off(o).on(o, i.delegate, s)
                : ((i.items = e), e.off(o).on(o, s)));
      },
      _openClick: function (i, s, o) {
        if (
          (void 0 !== o.midClick
            ? o.midClick
            : e.magnificPopup.defaults.midClick) ||
          !(2 === i.which || i.ctrlKey || i.metaKey || i.altKey || i.shiftKey)
        ) {
          var r =
            void 0 !== o.disableOn
              ? o.disableOn
              : e.magnificPopup.defaults.disableOn;
          if (r) {
            if (e.isFunction(r)) {
              if (!r.call(t)) return !0;
            } else if (v.width() < r) return !0;
          }
          i.type && (i.preventDefault(), t.isOpen && i.stopPropagation()),
            (o.el = e(i.mfpEl)),
            o.delegate && (o.items = s.find(o.delegate)),
            t.open(o);
        }
      },
      updateStatus: function (e, s) {
        if (t.preloader) {
          i !== e && t.container.removeClass("mfp-s-" + i),
            s || "loading" !== e || (s = t.st.tLoading);
          var o = { status: e, text: s };
          E("UpdateStatus", o),
            (e = o.status),
            (s = o.text),
            t.preloader.html(s),
            t.preloader.find("a").on("click", function (e) {
              e.stopImmediatePropagation();
            }),
            t.container.addClass("mfp-s-" + e),
            (i = e);
        }
      },
      _checkIfClose: function (i) {
        if (!e(i).hasClass(f)) {
          var s = t.st.closeOnContentClick,
            o = t.st.closeOnBgClick;
          if (
            (s && o) ||
            !t.content ||
            e(i).hasClass("mfp-close") ||
            (t.preloader && i === t.preloader[0])
          )
            return !0;
          if (i === t.content[0] || e.contains(t.content[0], i)) {
            if (s) return !0;
          } else if (o && e.contains(document, i)) return !0;
          return !1;
        }
      },
      _addClassToMFP: function (e) {
        t.bgOverlay.addClass(e), t.wrap.addClass(e);
      },
      _removeClassFromMFP: function (e) {
        this.bgOverlay.removeClass(e), t.wrap.removeClass(e);
      },
      _hasScrollBar: function (e) {
        return (
          (t.isIE7 ? s.height() : document.body.scrollHeight) >
          (e || v.height())
        );
      },
      _setFocus: function () {
        (t.st.focus ? t.content.find(t.st.focus).eq(0) : t.wrap).focus();
      },
      _onFocusIn: function (i) {
        return i.target === t.wrap[0] || e.contains(t.wrap[0], i.target)
          ? void 0
          : (t._setFocus(), !1);
      },
      _parseMarkup: function (t, i, s) {
        var o;
        s.data && (i = e.extend(s.data, i)),
          E(d, [t, i, s]),
          e.each(i, function (i, s) {
            if (void 0 === s || !1 === s) return !0;
            if ((o = i.split("_")).length > 1) {
              var r = t.find(p + "-" + o[0]);
              if (r.length > 0) {
                var n = o[1];
                "replaceWith" === n
                  ? r[0] !== s[0] && r.replaceWith(s)
                  : "img" === n
                    ? r.is("img")
                      ? r.attr("src", s)
                      : r.replaceWith(
                        e("<img>").attr("src", s).attr("class", r.attr("class"))
                      )
                    : r.attr(o[1], s);
              }
            } else t.find(p + "-" + i).html(s);
          });
      },
      _getScrollbarSize: function () {
        if (void 0 === t.scrollbarSize) {
          var e = document.createElement("div");
          (e.style.cssText =
            "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;"),
            document.body.appendChild(e),
            (t.scrollbarSize = e.offsetWidth - e.clientWidth),
            document.body.removeChild(e);
        }
        return t.scrollbarSize;
      },
    }),
      (e.magnificPopup = {
        instance: null,
        proto: g.prototype,
        modules: [],
        open: function (t, i) {
          return (
            x(),
            ((t = t ? e.extend(!0, {}, t) : {}).isObj = !0),
            (t.index = i || 0),
            this.instance.open(t)
          );
        },
        close: function () {
          return e.magnificPopup.instance && e.magnificPopup.instance.close();
        },
        registerModule: function (t, i) {
          i.options && (e.magnificPopup.defaults[t] = i.options),
            e.extend(this.proto, i.proto),
            this.modules.push(t);
        },
        defaults: {
          disableOn: 0,
          key: null,
          midClick: !1,
          mainClass: "",
          preloader: !0,
          focus: "",
          closeOnContentClick: !1,
          closeOnBgClick: !0,
          closeBtnInside: !0,
          showCloseBtn: !0,
          enableEscapeKey: !0,
          modal: !1,
          alignTop: !1,
          removalDelay: 0,
          prependTo: null,
          fixedContentPos: "auto",
          fixedBgPos: "auto",
          overflowY: "auto",
          closeMarkup:
            '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
          tClose: "Close (Esc)",
          tLoading: "Loading...",
          autoFocusLast: !0,
        },
      }),
      (e.fn.magnificPopup = function (i) {
        x();
        var s = e(this);
        if ("string" == typeof i) {
          if ("open" === i) {
            var o,
              r = y ? s.data("magnificPopup") : s[0].magnificPopup,
              n = parseInt(arguments[1], 10) || 0;
            r.items
              ? (o = r.items[n])
              : ((o = s),
                r.delegate && (o = o.find(r.delegate)),
                (o = o.eq(n))),
              t._openClick({ mfpEl: o }, s, r);
          } else
            t.isOpen && t[i].apply(t, Array.prototype.slice.call(arguments, 1));
        } else
          (i = e.extend(!0, {}, i)),
            y ? s.data("magnificPopup", i) : (s[0].magnificPopup = i),
            t.addGroup(s, i);
        return s;
      });
    var A,
      w,
      k,
      L = "inline",
      T = function () {
        k && (w.after(k.addClass(A)).detach(), (k = null));
      };
    e.magnificPopup.registerModule(L, {
      options: {
        hiddenClass: "hide",
        markup: "",
        tNotFound: "Content not found",
      },
      proto: {
        initInline: function () {
          t.types.push(L),
            b(a + "." + L, function () {
              T();
            });
        },
        getInline: function (i, s) {
          if ((T(), i.src)) {
            var o = t.st.inline,
              r = e(i.src);
            if (r.length) {
              var n = r[0].parentNode;
              n &&
                n.tagName &&
                (w || ((w = S((A = o.hiddenClass))), (A = "mfp-" + A)),
                  (k = r.after(w).detach().removeClass(A))),
                t.updateStatus("ready");
            } else t.updateStatus("error", o.tNotFound), (r = e("<div>"));
            return (i.inlineElement = r), r;
          }
          return t.updateStatus("ready"), t._parseMarkup(s, {}, i), s;
        },
      },
    });
    var P,
      q = "ajax",
      _ = function () {
        P && e(document.body).removeClass(P);
      },
      B = function () {
        _(), t.req && t.req.abort();
      };
    e.magnificPopup.registerModule(q, {
      options: {
        settings: null,
        cursor: "mfp-ajax-cur",
        tError: '<a href="%url%">The content</a> could not be loaded.',
      },
      proto: {
        initAjax: function () {
          t.types.push(q),
            (P = t.st.ajax.cursor),
            b(a + "." + q, B),
            b("BeforeChange." + q, B);
        },
        getAjax: function (i) {
          P && e(document.body).addClass(P), t.updateStatus("loading");
          var s = e.extend(
            {
              url: i.src,
              success: function (s, o, r) {
                var n = { data: s, xhr: r };
                E("ParseAjax", n),
                  t.appendContent(e(n.data), q),
                  (i.finished = !0),
                  _(),
                  t._setFocus(),
                  setTimeout(function () {
                    t.wrap.addClass(h);
                  }, 16),
                  t.updateStatus("ready"),
                  E("AjaxContentAdded");
              },
              error: function () {
                _(),
                  (i.finished = i.loadError = !0),
                  t.updateStatus(
                    "error",
                    t.st.ajax.tError.replace("%url%", i.src)
                  );
              },
            },
            t.st.ajax.settings
          );
          return (t.req = e.ajax(s)), "";
        },
      },
    });
    var M,
      O,
      V = function (i) {
        if (i.data && void 0 !== i.data.title) return i.data.title;
        var s = t.st.image.titleSrc;
        if (s) {
          if (e.isFunction(s)) return s.call(t, i);
          if (i.el) return i.el.attr(s) || "";
        }
        return "";
      };
    e.magnificPopup.registerModule("image", {
      options: {
        markup:
          '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
        cursor: "mfp-zoom-out-cur",
        titleSrc: "title",
        verticalFit: !0,
        tError: '<a href="%url%">The image</a> could not be loaded.',
      },
      proto: {
        initImage: function () {
          var i = t.st.image,
            s = ".image";
          t.types.push("image"),
            b(c + s, function () {
              "image" === t.currItem.type &&
                i.cursor &&
                e(document.body).addClass(i.cursor);
            }),
            b(a + s, function () {
              i.cursor && e(document.body).removeClass(i.cursor),
                v.off("resize" + p);
            }),
            b("Resize" + s, t.resizeImage),
            t.isLowIE && b("AfterChange", t.resizeImage);
        },
        resizeImage: function () {
          var e = t.currItem;
          if (e && e.img && t.st.image.verticalFit) {
            var i = 0;
            t.isLowIE &&
              (i =
                parseInt(e.img.css("padding-top"), 10) +
                parseInt(e.img.css("padding-bottom"), 10)),
              e.img.css("max-height", t.wH - i);
          }
        },
        _onImageHasSize: function (e) {
          e.img &&
            ((e.hasSize = !0),
              M && clearInterval(M),
              (e.isCheckingImgSize = !1),
              E("ImageHasSize", e),
              e.imgHidden &&
              (t.content && t.content.removeClass("mfp-loading"),
                (e.imgHidden = !1)));
        },
        findImageSize: function (e) {
          var i = 0,
            s = e.img[0],
            o = function (r) {
              M && clearInterval(M),
                (M = setInterval(function () {
                  return s.naturalWidth > 0
                    ? void t._onImageHasSize(e)
                    : (i > 200 && clearInterval(M),
                      void (3 == ++i
                        ? o(10)
                        : 40 === i
                          ? o(50)
                          : 100 === i && o(500)));
                }, r));
            };
          o(1);
        },
        getImage: function (i, s) {
          var o = 0,
            r = function () {
              i &&
                (i.img[0].complete
                  ? (i.img.off(".mfploader"),
                    i === t.currItem &&
                    (t._onImageHasSize(i), t.updateStatus("ready")),
                    (i.hasSize = !0),
                    (i.loaded = !0),
                    E("ImageLoadComplete"))
                  : 200 > ++o
                    ? setTimeout(r, 100)
                    : n());
            },
            n = function () {
              i &&
                (i.img.off(".mfploader"),
                  i === t.currItem &&
                  (t._onImageHasSize(i),
                    t.updateStatus("error", a.tError.replace("%url%", i.src))),
                  (i.hasSize = !0),
                  (i.loaded = !0),
                  (i.loadError = !0));
            },
            a = t.st.image,
            l = s.find(".mfp-img");
          if (l.length) {
            var d = document.createElement("img");
            (d.className = "mfp-img"),
              i.el &&
              i.el.find("img").length &&
              (d.alt = i.el.find("img").attr("alt")),
              (i.img = e(d).on("load.mfploader", r).on("error.mfploader", n)),
              (d.src = i.src),
              l.is("img") && (i.img = i.img.clone()),
              (d = i.img[0]).naturalWidth > 0
                ? (i.hasSize = !0)
                : d.width || (i.hasSize = !1);
          }
          return (
            t._parseMarkup(s, { title: V(i), img_replaceWith: i.img }, i),
            t.resizeImage(),
            i.hasSize
              ? (M && clearInterval(M),
                i.loadError
                  ? (s.addClass("mfp-loading"),
                    t.updateStatus("error", a.tError.replace("%url%", i.src)))
                  : (s.removeClass("mfp-loading"), t.updateStatus("ready")),
                s)
              : (t.updateStatus("loading"),
                (i.loading = !0),
                i.hasSize ||
                ((i.imgHidden = !0),
                  s.addClass("mfp-loading"),
                  t.findImageSize(i)),
                s)
          );
        },
      },
    }),
      e.magnificPopup.registerModule("zoom", {
        options: {
          enabled: !1,
          easing: "ease-in-out",
          duration: 300,
          opener: function (e) {
            return e.is("img") ? e : e.find("img");
          },
        },
        proto: {
          initZoom: function () {
            var e,
              i = t.st.zoom,
              s = ".zoom";
            if (i.enabled && t.supportsTransition) {
              var o,
                r,
                n = i.duration,
                d = function (e) {
                  var t = e
                    .clone()
                    .removeAttr("style")
                    .removeAttr("class")
                    .addClass("mfp-animated-image"),
                    s = "all " + i.duration / 1e3 + "s " + i.easing,
                    o = {
                      position: "fixed",
                      zIndex: 9999,
                      left: 0,
                      top: 0,
                      "-webkit-backface-visibility": "hidden",
                    },
                    r = "transition";
                  return (
                    (o["-webkit-" + r] =
                      o["-moz-" + r] =
                      o["-o-" + r] =
                      o[r] =
                      s),
                    t.css(o),
                    t
                  );
                },
                c = function () {
                  t.content.css("visibility", "visible");
                };
              b("BuildControls" + s, function () {
                if (t._allowZoom()) {
                  if (
                    (clearTimeout(o),
                      t.content.css("visibility", "hidden"),
                      !(e = t._getItemToZoom()))
                  )
                    return void c();
                  (r = d(e)).css(t._getOffset()),
                    t.wrap.append(r),
                    (o = setTimeout(function () {
                      r.css(t._getOffset(!0)),
                        (o = setTimeout(function () {
                          c(),
                            setTimeout(function () {
                              r.remove(),
                                (e = r = null),
                                E("ZoomAnimationEnded");
                            }, 16);
                        }, n));
                    }, 16));
                }
              }),
                b(l + s, function () {
                  if (t._allowZoom()) {
                    if ((clearTimeout(o), (t.st.removalDelay = n), !e)) {
                      if (!(e = t._getItemToZoom())) return;
                      r = d(e);
                    }
                    r.css(t._getOffset(!0)),
                      t.wrap.append(r),
                      t.content.css("visibility", "hidden"),
                      setTimeout(function () {
                        r.css(t._getOffset());
                      }, 16);
                  }
                }),
                b(a + s, function () {
                  t._allowZoom() && (c(), r && r.remove(), (e = null));
                });
            }
          },
          _allowZoom: function () {
            return "image" === t.currItem.type;
          },
          _getItemToZoom: function () {
            return !!t.currItem.hasSize && t.currItem.img;
          },
          _getOffset: function (i) {
            var s,
              o = (s = i
                ? t.currItem.img
                : t.st.zoom.opener(t.currItem.el || t.currItem)).offset(),
              r = parseInt(s.css("padding-top"), 10),
              n = parseInt(s.css("padding-bottom"), 10);
            o.top -= e(window).scrollTop() - r;
            var a = {
              width: s.width(),
              height: (y ? s.innerHeight() : s[0].offsetHeight) - n - r,
            };
            return (
              (void 0 === O &&
                (O = void 0 !== document.createElement("p").style.MozTransform),
                O)
                ? (a["-moz-transform"] = a.transform =
                  "translate(" + o.left + "px," + o.top + "px)")
                : ((a.left = o.left), (a.top = o.top)),
              a
            );
          },
        },
      });
    var D = "iframe",
      z = function (e) {
        if (t.currTemplate[D]) {
          var i = t.currTemplate[D].find("iframe");
          i.length &&
            (e || (i[0].src = "//about:blank"),
              t.isIE8 && i.css("display", e ? "block" : "none"));
        }
      };
    e.magnificPopup.registerModule(D, {
      options: {
        markup:
          '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
        srcAction: "iframe_src",
        patterns: {
          youtube: {
            index: "youtube.com",
            id: "v=",
            src: "//www.youtube.com/embed/%id%?autoplay=1",
          },
          vimeo: {
            index: "vimeo.com/",
            id: "/",
            src: "//player.vimeo.com/video/%id%?autoplay=1",
          },
          gmaps: { index: "//maps.google.", src: "%id%&output=embed" },
        },
      },
      proto: {
        initIframe: function () {
          t.types.push(D),
            b("BeforeChange", function (e, t, i) {
              t !== i && (t === D ? z() : i === D && z(!0));
            }),
            b(a + "." + D, function () {
              z();
            });
        },
        getIframe: function (i, s) {
          var o = i.src,
            r = t.st.iframe;
          e.each(r.patterns, function () {
            return o.indexOf(this.index) > -1
              ? (this.id &&
                (o =
                  "string" == typeof this.id
                    ? o.substr(
                      o.lastIndexOf(this.id) + this.id.length,
                      o.length
                    )
                    : this.id.call(this, o)),
                (o = this.src.replace("%id%", o)),
                !1)
              : void 0;
          });
          var n = {};
          return (
            r.srcAction && (n[r.srcAction] = o),
            t._parseMarkup(s, n, i),
            t.updateStatus("ready"),
            s
          );
        },
      },
    });
    var F = function (e) {
      var i = t.items.length;
      return e > i - 1 ? e - i : 0 > e ? i + e : e;
    },
      j = function (e, t, i) {
        return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, i);
      };
    e.magnificPopup.registerModule("gallery", {
      options: {
        enabled: !1,
        arrowMarkup:
          '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
        preload: [0, 2],
        navigateByImgClick: !0,
        arrows: !0,
        tPrev: "Previous (Left arrow key)",
        tNext: "Next (Right arrow key)",
        tCounter: "%curr% of %total%",
      },
      proto: {
        initGallery: function () {
          var i = t.st.gallery,
            o = ".mfp-gallery";
          return (
            (t.direction = !0),
            !!i &&
            !!i.enabled &&
            ((r += " mfp-gallery"),
              b(c + o, function () {
                i.navigateByImgClick &&
                  t.wrap.on("click" + o, ".mfp-img", function () {
                    return t.items.length > 1 ? (t.next(), !1) : void 0;
                  }),
                  s.on("keydown" + o, function (e) {
                    37 === e.keyCode ? t.prev() : 39 === e.keyCode && t.next();
                  });
              }),
              b("UpdateStatus" + o, function (e, i) {
                i.text &&
                  (i.text = j(i.text, t.currItem.index, t.items.length));
              }),
              b(d + o, function (e, s, o, r) {
                var n = t.items.length;
                o.counter = n > 1 ? j(i.tCounter, r.index, n) : "";
              }),
              b("BuildControls" + o, function () {
                if (t.items.length > 1 && i.arrows && !t.arrowLeft) {
                  var s = i.arrowMarkup,
                    o = (t.arrowLeft = e(
                      s.replace(/%title%/gi, i.tPrev).replace(/%dir%/gi, "left")
                    ).addClass(f)),
                    r = (t.arrowRight = e(
                      s
                        .replace(/%title%/gi, i.tNext)
                        .replace(/%dir%/gi, "right")
                    ).addClass(f));
                  o.click(function () {
                    t.prev();
                  }),
                    r.click(function () {
                      t.next();
                    }),
                    t.container.append(o.add(r));
                }
              }),
              b(u + o, function () {
                t._preloadTimeout && clearTimeout(t._preloadTimeout),
                  (t._preloadTimeout = setTimeout(function () {
                    t.preloadNearbyImages(), (t._preloadTimeout = null);
                  }, 16));
              }),
              void b(a + o, function () {
                s.off(o),
                  t.wrap.off("click" + o),
                  (t.arrowRight = t.arrowLeft = null);
              }))
          );
        },
        next: function () {
          (t.direction = !0), (t.index = F(t.index + 1)), t.updateItemHTML();
        },
        prev: function () {
          (t.direction = !1), (t.index = F(t.index - 1)), t.updateItemHTML();
        },
        goTo: function (e) {
          (t.direction = e >= t.index), (t.index = e), t.updateItemHTML();
        },
        preloadNearbyImages: function () {
          var e,
            i = t.st.gallery.preload,
            s = Math.min(i[0], t.items.length),
            o = Math.min(i[1], t.items.length);
          for (e = 1; e <= (t.direction ? o : s); e++)
            t._preloadItem(t.index + e);
          for (e = 1; e <= (t.direction ? s : o); e++)
            t._preloadItem(t.index - e);
        },
        _preloadItem: function (i) {
          if (((i = F(i)), !t.items[i].preloaded)) {
            var s = t.items[i];
            s.parsed || (s = t.parseEl(i)),
              E("LazyLoad", s),
              "image" === s.type &&
              (s.img = e('<img class="mfp-img" />')
                .on("load.mfploader", function () {
                  s.hasSize = !0;
                })
                .on("error.mfploader", function () {
                  (s.hasSize = !0), (s.loadError = !0), E("LazyLoadError", s);
                })
                .attr("src", s.src)),
              (s.preloaded = !0);
          }
        },
      },
    });
    var H = "retina";
    e.magnificPopup.registerModule(H, {
      options: {
        replaceSrc: function (e) {
          return e.src.replace(/\.\w+$/, function (e) {
            return "@2x" + e;
          });
        },
        ratio: 1,
      },
      proto: {
        initRetina: function () {
          if (window.devicePixelRatio > 1) {
            var e = t.st.retina,
              i = e.ratio;
            (i = isNaN(i) ? i() : i) > 1 &&
              (b("ImageHasSize." + H, function (e, t) {
                t.img.css({
                  "max-width": t.img[0].naturalWidth / i,
                  width: "100%",
                });
              }),
                b("ElementParse." + H, function (t, s) {
                  s.src = e.replaceSrc(s, i);
                }));
          }
        },
      },
    }),
      x();
  });

function serializeJSON(form) {
  const formData = new FormData(form);
  const pairs = {};
  const consistent = {};
  for (const [name, value] of formData) {
    if (value === null || value === "" || JSON.stringify(value) === "{}") {
      continue;
    } else if (name == "form_type" || name == "utf8") {
      consistent[name] = value;
    } else {
      pairs[name] = value;
    }
  }
  return JSON.stringify({ consistent, data: pairs }, null, 2);
}

class FormBuilder extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.thanks = this.querySelector("#thanks");
    this.form_submit = this.form.querySelector("#custom-form-submit");
    this.form_submit_text = this.form_submit.querySelector("span");

    if (!this.form) return;

    this.form.addEventListener("submit", this.formSubmit.bind(this));
    this.form
      .querySelectorAll(".field__input-file")
      .forEach((input) =>
        input.addEventListener("change", this.onFileInput.bind(this))
      );
  }

  onFileInput(event) {
    const input = event.target;
    const file_link = input.nextElementSibling;
    if (input.files) {
      this.form_submit.classList.add("button--loading");
      this.form_submit.disabled = true;

      const file = input.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("document", this.form_submit.dataset.source);

      var res = Array.from(formData.entries(), ([key, prop]) => ({
        [key]: {
          ContentLength: typeof prop === "string" ? prop.length : prop.size,
        },
      }));

      if (file.size > 5000000) {
        alert("File size too large, please reduce file size and resubmit");
        input.value = "";
      } else {
        formData.append("service", input.dataset.service);

        if (!input.dataset.connection) {
          alert("Upload not Created");
          return;
        }

        fetch(input.dataset.connection, {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            file_link.value = data.success;
            this.form_submit.classList.remove("button--loading");
            this.form_submit.disabled = false;
          })
          .catch((error) => {
            this.form_submit.classList.remove("button--loading");
            this.form_submit.disabled = false;
          });
      }
    }
  }

  formSubmit(event) {
    event.preventDefault();
    this.form_submit.classList.add("animate");
    this.form_submit.disabled = true;
    this.form_submit_text.innerText = window.proStrings.submitting;
    let redirect_url;
    if (this.hasAttribute("data-redirect")) {
      redirect_url = this.dataset.redirect;
    }
    fetch(this.dataset.send, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: serializeJSON(this.form),
    })
      .then((response) => response.json())
      .then((data) => {
        var form_error = document.getElementById("form_error");
        if (!form_error) {
          form_error = document.createElement("div");
          form_error.id = "form_error";
          this.form_submit.parentNode.insertBefore(
            form_error,
            this.form_submit.nextSibling
          );
        }
        this.form_submit.classList.remove("animate");
        this.form_submit.classList.add("success");
        setTimeout(
          function () {
            if (data.success) {
              this.form.classList.add("hidden");
              this.thanks.classList.remove("hidden");
              this.thanks.scrollIntoView();
              if (redirect_url) {
                setTimeout(function () {
                  window.location.href = redirect_url;
                }, 500);
              }
            } else {
              form_error.innerText = data.error;
            }
          }.bind(this),
          500
        );
      })
      .catch((error) => {
        console.error("Error:", error);
        this.form_submit.classList.remove("animate");
        this.form_submit.classList.add("error");
        this.form_submit.disabled = false;
        this.form_submit_text.innerText = window.proStrings.apply;
      });
  }
}

customElements.define("form-builder", FormBuilder);